/* tslint:disable */
/* eslint-disable */
/**
 * Nal Von Minden API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.9.26
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface IAnalyzeOutputSchemaInput
 */
export interface IAnalyzeOutputSchemaInput {
    /**
     * 
     * @type {IDrugTestList}
     * @memberof IAnalyzeOutputSchemaInput
     */
    'drug_test_type'?: IDrugTestList | null;
    /**
     * 
     * @type {Array<ISubstanceResult>}
     * @memberof IAnalyzeOutputSchemaInput
     */
    'substances'?: Array<ISubstanceResult>;
    /**
     * 
     * @type {Array<IExtraSubstanceResult>}
     * @memberof IAnalyzeOutputSchemaInput
     */
    'extra_substances'?: Array<IExtraSubstanceResult>;
}


/**
 * 
 * @export
 * @interface IAnalyzeOutputSchemaOutput
 */
export interface IAnalyzeOutputSchemaOutput {
    /**
     * 
     * @type {IDrugTestList}
     * @memberof IAnalyzeOutputSchemaOutput
     */
    'drug_test_type'?: IDrugTestList | null;
    /**
     * 
     * @type {Array<ISubstanceResult>}
     * @memberof IAnalyzeOutputSchemaOutput
     */
    'substances'?: Array<ISubstanceResult>;
    /**
     * 
     * @type {Array<IExtraSubstanceResult>}
     * @memberof IAnalyzeOutputSchemaOutput
     */
    'extra_substances'?: Array<IExtraSubstanceResult>;
}


/**
 * 
 * @export
 * @interface IBodyGetAccessToken
 */
export interface IBodyGetAccessToken {
    /**
     * 
     * @type {string}
     * @memberof IBodyGetAccessToken
     */
    'grant_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IBodyGetAccessToken
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof IBodyGetAccessToken
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof IBodyGetAccessToken
     */
    'scope'?: string;
    /**
     * 
     * @type {string}
     * @memberof IBodyGetAccessToken
     */
    'client_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IBodyGetAccessToken
     */
    'client_secret'?: string | null;
}
/**
 * 
 * @export
 * @interface IBodyMobileImportPatientsCSV
 */
export interface IBodyMobileImportPatientsCSV {
    /**
     * 
     * @type {File}
     * @memberof IBodyMobileImportPatientsCSV
     */
    'file': File;
}
/**
 * 
 * @export
 * @interface IBodyMobileUploadDoctorAttachment
 */
export interface IBodyMobileUploadDoctorAttachment {
    /**
     * 
     * @type {File}
     * @memberof IBodyMobileUploadDoctorAttachment
     */
    'file': File;
}
/**
 * 
 * @export
 * @interface IBodyMobileUploadReportAttachment
 */
export interface IBodyMobileUploadReportAttachment {
    /**
     * 
     * @type {File}
     * @memberof IBodyMobileUploadReportAttachment
     */
    'file': File;
}
/**
 * 
 * @export
 * @interface IBodyWebImportPatientsCSV
 */
export interface IBodyWebImportPatientsCSV {
    /**
     * 
     * @type {File}
     * @memberof IBodyWebImportPatientsCSV
     */
    'file': File;
}
/**
 * 
 * @export
 * @interface IBodyWebUploadDoctorAttachment
 */
export interface IBodyWebUploadDoctorAttachment {
    /**
     * 
     * @type {File}
     * @memberof IBodyWebUploadDoctorAttachment
     */
    'file': File;
}
/**
 * 
 * @export
 * @interface IBodyWebUploadPDFConfigurationAttachment
 */
export interface IBodyWebUploadPDFConfigurationAttachment {
    /**
     * 
     * @type {File}
     * @memberof IBodyWebUploadPDFConfigurationAttachment
     */
    'file': File;
}
/**
 * 
 * @export
 * @interface IBodyWebUploadReportAttachment
 */
export interface IBodyWebUploadReportAttachment {
    /**
     * 
     * @type {File}
     * @memberof IBodyWebUploadReportAttachment
     */
    'file': File;
}
/**
 * 
 * @export
 * @interface IChangePasswordRequest
 */
export interface IChangePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof IChangePasswordRequest
     */
    'old_password': string;
    /**
     * 
     * @type {string}
     * @memberof IChangePasswordRequest
     */
    'new_password': string;
}
/**
 * 
 * @export
 * @interface ICompanyCreate
 */
export interface ICompanyCreate {
    /**
     * 
     * @type {string}
     * @memberof ICompanyCreate
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface ICompanySchema
 */
export interface ICompanySchema {
    /**
     * 
     * @type {string}
     * @memberof ICompanySchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ICompanySchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ICompanySchema
     */
    'medical_center_id': string;
    /**
     * 
     * @type {string}
     * @memberof ICompanySchema
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ICompanySchema
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface ICompanyUpdate
 */
export interface ICompanyUpdate {
    /**
     * 
     * @type {string}
     * @memberof ICompanyUpdate
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface ICurrentMedicalCenterUpdate
 */
export interface ICurrentMedicalCenterUpdate {
    /**
     * 
     * @type {string}
     * @memberof ICurrentMedicalCenterUpdate
     */
    'vat_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ICurrentMedicalCenterUpdate
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ICurrentMedicalCenterUpdate
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ICurrentMedicalCenterUpdate
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ICurrentMedicalCenterUpdate
     */
    'language': string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const IDoctorAttachmentType = {
    Signature: 'signature'
} as const;

export type IDoctorAttachmentType = typeof IDoctorAttachmentType[keyof typeof IDoctorAttachmentType];


/**
 * 
 * @export
 * @interface IDoctorCreate
 */
export interface IDoctorCreate {
    /**
     * 
     * @type {string}
     * @memberof IDoctorCreate
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IDoctorCreate
     */
    'last_name'?: string | null;
}
/**
 * 
 * @export
 * @interface IDoctorSchema
 */
export interface IDoctorSchema {
    /**
     * 
     * @type {string}
     * @memberof IDoctorSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof IDoctorSchema
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof IDoctorSchema
     */
    'last_name': string;
    /**
     * 
     * @type {boolean}
     * @memberof IDoctorSchema
     */
    'has_signature'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IDoctorSchema
     */
    'is_active'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof IDoctorSchema
     */
    'medical_center_id': string;
    /**
     * 
     * @type {string}
     * @memberof IDoctorSchema
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof IDoctorSchema
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface IDoctorUpdate
 */
export interface IDoctorUpdate {
    /**
     * 
     * @type {string}
     * @memberof IDoctorUpdate
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IDoctorUpdate
     */
    'last_name'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const IDrugTestList = {
    Sku542020n25: 'sku_542020n25',
    Sku104075: 'sku_104075',
    Sku104092: 'sku_104092',
    Sku910082: 'sku_910082',
    Sku910091: 'sku_910091',
    Sku911070: 'sku_911070',
    Sku1160070: 'sku_1160070',
    Sku1160080: 'sku_1160080',
    Sku1160090: 'sku_1160090',
    Sku1160091: 'sku_1160091'
} as const;

export type IDrugTestList = typeof IDrugTestList[keyof typeof IDrugTestList];


/**
 * 
 * @export
 * @enum {string}
 */

export const IExtraSubstanceName = {
    Creatinine: 'creatinine',
    Ph: 'ph'
} as const;

export type IExtraSubstanceName = typeof IExtraSubstanceName[keyof typeof IExtraSubstanceName];


/**
 * 
 * @export
 * @enum {string}
 */

export const IExtraSubstanceOutcome = {
    Unset: 'unset',
    Normal: 'normal',
    Abnormal: 'abnormal'
} as const;

export type IExtraSubstanceOutcome = typeof IExtraSubstanceOutcome[keyof typeof IExtraSubstanceOutcome];


/**
 * 
 * @export
 * @interface IExtraSubstanceResult
 */
export interface IExtraSubstanceResult {
    /**
     * 
     * @type {IExtraSubstanceName}
     * @memberof IExtraSubstanceResult
     */
    'name': IExtraSubstanceName;
    /**
     * 
     * @type {IExtraSubstanceOutcome}
     * @memberof IExtraSubstanceResult
     */
    'outcome': IExtraSubstanceOutcome;
}


/**
 * 
 * @export
 * @interface IForgotPasswordRequest
 */
export interface IForgotPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof IForgotPasswordRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface IHTTPValidationError
 */
export interface IHTTPValidationError {
    /**
     * 
     * @type {Array<IValidationError>}
     * @memberof IHTTPValidationError
     */
    'detail'?: Array<IValidationError>;
}
/**
 * 
 * @export
 * @interface IMedicalCenterCreate
 */
export interface IMedicalCenterCreate {
    /**
     * 
     * @type {string}
     * @memberof IMedicalCenterCreate
     */
    'vat_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IMedicalCenterCreate
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IMedicalCenterCreate
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IMedicalCenterCreate
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IMedicalCenterCreate
     */
    'language': string | null;
    /**
     * 
     * @type {string}
     * @memberof IMedicalCenterCreate
     */
    'user_email'?: string | null;
}
/**
 * 
 * @export
 * @interface IMedicalCenterDeleteSchema
 */
export interface IMedicalCenterDeleteSchema {
    /**
     * 
     * @type {string}
     * @memberof IMedicalCenterDeleteSchema
     */
    'user_email': string;
}
/**
 * 
 * @export
 * @interface IMedicalCenterSchema
 */
export interface IMedicalCenterSchema {
    /**
     * 
     * @type {string}
     * @memberof IMedicalCenterSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof IMedicalCenterSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof IMedicalCenterSchema
     */
    'vat_number': string;
    /**
     * 
     * @type {string}
     * @memberof IMedicalCenterSchema
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IMedicalCenterSchema
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IMedicalCenterSchema
     */
    'pdf_configuration_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IMedicalCenterSchema
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof IMedicalCenterSchema
     */
    'user_email': string;
    /**
     * 
     * @type {boolean}
     * @memberof IMedicalCenterSchema
     */
    'is_active': boolean;
    /**
     * 
     * @type {string}
     * @memberof IMedicalCenterSchema
     */
    'language': string;
    /**
     * 
     * @type {string}
     * @memberof IMedicalCenterSchema
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof IMedicalCenterSchema
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface IMedicalCenterUpdate
 */
export interface IMedicalCenterUpdate {
    /**
     * 
     * @type {string}
     * @memberof IMedicalCenterUpdate
     */
    'vat_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IMedicalCenterUpdate
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IMedicalCenterUpdate
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IMedicalCenterUpdate
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IMedicalCenterUpdate
     */
    'language': string | null;
    /**
     * 
     * @type {string}
     * @memberof IMedicalCenterUpdate
     */
    'user_email'?: string | null;
}
/**
 * 
 * @export
 * @interface IMonthlyStatisticsSchema
 */
export interface IMonthlyStatisticsSchema {
    /**
     * 
     * @type {number}
     * @memberof IMonthlyStatisticsSchema
     */
    'year': number;
    /**
     * 
     * @type {number}
     * @memberof IMonthlyStatisticsSchema
     */
    'month': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof IMonthlyStatisticsSchema
     */
    'reports_by_test_type': { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof IMonthlyStatisticsSchema
     */
    'draft_reports': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const IPDFConfigAttachmentType = {
    Logo: 'logo'
} as const;

export type IPDFConfigAttachmentType = typeof IPDFConfigAttachmentType[keyof typeof IPDFConfigAttachmentType];


/**
 * 
 * @export
 * @interface IPDFConfigurationCreate
 */
export interface IPDFConfigurationCreate {
    /**
     * 
     * @type {string}
     * @memberof IPDFConfigurationCreate
     */
    'header_title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPDFConfigurationCreate
     */
    'header_subtitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPDFConfigurationCreate
     */
    'privacy_policy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPDFConfigurationCreate
     */
    'free_text_1'?: string | null;
    /**
     * 
     * @type {IPatientDataOptions}
     * @memberof IPDFConfigurationCreate
     */
    'patient_data_options'?: IPatientDataOptions;
    /**
     * 
     * @type {IReportDataOptions}
     * @memberof IPDFConfigurationCreate
     */
    'report_data_options'?: IReportDataOptions;
}
/**
 * 
 * @export
 * @interface IPDFConfigurationSchema
 */
export interface IPDFConfigurationSchema {
    /**
     * 
     * @type {string}
     * @memberof IPDFConfigurationSchema
     */
    'header_title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPDFConfigurationSchema
     */
    'header_subtitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPDFConfigurationSchema
     */
    'privacy_policy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPDFConfigurationSchema
     */
    'free_text_1'?: string | null;
    /**
     * 
     * @type {IPatientDataOptions}
     * @memberof IPDFConfigurationSchema
     */
    'patient_data_options'?: IPatientDataOptions;
    /**
     * 
     * @type {IReportDataOptions}
     * @memberof IPDFConfigurationSchema
     */
    'report_data_options'?: IReportDataOptions;
    /**
     * 
     * @type {string}
     * @memberof IPDFConfigurationSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof IPDFConfigurationSchema
     */
    'medical_center_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof IPDFConfigurationSchema
     */
    'has_logo': boolean;
    /**
     * 
     * @type {string}
     * @memberof IPDFConfigurationSchema
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof IPDFConfigurationSchema
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface IPDFConfigurationUpdate
 */
export interface IPDFConfigurationUpdate {
    /**
     * 
     * @type {string}
     * @memberof IPDFConfigurationUpdate
     */
    'header_title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPDFConfigurationUpdate
     */
    'header_subtitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPDFConfigurationUpdate
     */
    'privacy_policy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPDFConfigurationUpdate
     */
    'free_text_1'?: string | null;
    /**
     * 
     * @type {IPatientDataOptions}
     * @memberof IPDFConfigurationUpdate
     */
    'patient_data_options'?: IPatientDataOptions;
    /**
     * 
     * @type {IReportDataOptions}
     * @memberof IPDFConfigurationUpdate
     */
    'report_data_options'?: IReportDataOptions;
}
/**
 * 
 * @export
 * @interface IPagedResponseSchemaCompanySchema
 */
export interface IPagedResponseSchemaCompanySchema {
    /**
     * 
     * @type {number}
     * @memberof IPagedResponseSchemaCompanySchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof IPagedResponseSchemaCompanySchema
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof IPagedResponseSchemaCompanySchema
     */
    'size': number;
    /**
     * 
     * @type {Array<ICompanySchema>}
     * @memberof IPagedResponseSchemaCompanySchema
     */
    'results': Array<ICompanySchema>;
}
/**
 * 
 * @export
 * @interface IPagedResponseSchemaDoctorSchema
 */
export interface IPagedResponseSchemaDoctorSchema {
    /**
     * 
     * @type {number}
     * @memberof IPagedResponseSchemaDoctorSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof IPagedResponseSchemaDoctorSchema
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof IPagedResponseSchemaDoctorSchema
     */
    'size': number;
    /**
     * 
     * @type {Array<IDoctorSchema>}
     * @memberof IPagedResponseSchemaDoctorSchema
     */
    'results': Array<IDoctorSchema>;
}
/**
 * 
 * @export
 * @interface IPagedResponseSchemaMedicalCenterSchema
 */
export interface IPagedResponseSchemaMedicalCenterSchema {
    /**
     * 
     * @type {number}
     * @memberof IPagedResponseSchemaMedicalCenterSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof IPagedResponseSchemaMedicalCenterSchema
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof IPagedResponseSchemaMedicalCenterSchema
     */
    'size': number;
    /**
     * 
     * @type {Array<IMedicalCenterSchema>}
     * @memberof IPagedResponseSchemaMedicalCenterSchema
     */
    'results': Array<IMedicalCenterSchema>;
}
/**
 * 
 * @export
 * @interface IPagedResponseSchemaPatientSchema
 */
export interface IPagedResponseSchemaPatientSchema {
    /**
     * 
     * @type {number}
     * @memberof IPagedResponseSchemaPatientSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof IPagedResponseSchemaPatientSchema
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof IPagedResponseSchemaPatientSchema
     */
    'size': number;
    /**
     * 
     * @type {Array<IPatientSchema>}
     * @memberof IPagedResponseSchemaPatientSchema
     */
    'results': Array<IPatientSchema>;
}
/**
 * 
 * @export
 * @interface IPagedResponseSchemaReportSummarySchema
 */
export interface IPagedResponseSchemaReportSummarySchema {
    /**
     * 
     * @type {number}
     * @memberof IPagedResponseSchemaReportSummarySchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof IPagedResponseSchemaReportSummarySchema
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof IPagedResponseSchemaReportSummarySchema
     */
    'size': number;
    /**
     * 
     * @type {Array<IReportSummarySchema>}
     * @memberof IPagedResponseSchemaReportSummarySchema
     */
    'results': Array<IReportSummarySchema>;
}
/**
 * 
 * @export
 * @interface IPagedResponseSchemaUserSchema
 */
export interface IPagedResponseSchemaUserSchema {
    /**
     * 
     * @type {number}
     * @memberof IPagedResponseSchemaUserSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof IPagedResponseSchemaUserSchema
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof IPagedResponseSchemaUserSchema
     */
    'size': number;
    /**
     * 
     * @type {Array<IUserSchema>}
     * @memberof IPagedResponseSchemaUserSchema
     */
    'results': Array<IUserSchema>;
}
/**
 * 
 * @export
 * @interface IPatientCreate
 */
export interface IPatientCreate {
    /**
     * 
     * @type {string}
     * @memberof IPatientCreate
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPatientCreate
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPatientCreate
     */
    'tax_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPatientCreate
     */
    'birth_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPatientCreate
     */
    'job_title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPatientCreate
     */
    'residence'?: string | null;
    /**
     * 
     * @type {ICompanyCreate}
     * @memberof IPatientCreate
     */
    'company'?: ICompanyCreate | null;
}
/**
 * 
 * @export
 * @interface IPatientDataOptions
 */
export interface IPatientDataOptions {
    /**
     * 
     * @type {boolean}
     * @memberof IPatientDataOptions
     */
    'show_birth_date'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPatientDataOptions
     */
    'show_tax_code'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPatientDataOptions
     */
    'show_company'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPatientDataOptions
     */
    'show_job_title'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPatientDataOptions
     */
    'show_residence'?: boolean;
}
/**
 * 
 * @export
 * @interface IPatientSchema
 */
export interface IPatientSchema {
    /**
     * 
     * @type {string}
     * @memberof IPatientSchema
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPatientSchema
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPatientSchema
     */
    'tax_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPatientSchema
     */
    'birth_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPatientSchema
     */
    'job_title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPatientSchema
     */
    'residence'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPatientSchema
     */
    'id': string;
    /**
     * 
     * @type {ICompanySchema}
     * @memberof IPatientSchema
     */
    'company'?: ICompanySchema | null;
    /**
     * 
     * @type {string}
     * @memberof IPatientSchema
     */
    'medical_center_id': string;
    /**
     * 
     * @type {string}
     * @memberof IPatientSchema
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof IPatientSchema
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface IPatientUpdate
 */
export interface IPatientUpdate {
    /**
     * 
     * @type {string}
     * @memberof IPatientUpdate
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPatientUpdate
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPatientUpdate
     */
    'tax_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPatientUpdate
     */
    'birth_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPatientUpdate
     */
    'job_title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPatientUpdate
     */
    'residence'?: string | null;
    /**
     * 
     * @type {ICompanyCreate}
     * @memberof IPatientUpdate
     */
    'company'?: ICompanyCreate | null;
}
/**
 * 
 * @export
 * @interface IRefreshTokenRequest
 */
export interface IRefreshTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof IRefreshTokenRequest
     */
    'refresh_token': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const IReportAttachmentType = {
    PhotoBlister: 'photo_blister',
    PatientSignature: 'patient_signature'
} as const;

export type IReportAttachmentType = typeof IReportAttachmentType[keyof typeof IReportAttachmentType];


/**
 * 
 * @export
 * @interface IReportBulkDeleteRequest
 */
export interface IReportBulkDeleteRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof IReportBulkDeleteRequest
     */
    'report_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface IReportCreate
 */
export interface IReportCreate {
    /**
     * 
     * @type {string}
     * @memberof IReportCreate
     */
    'doctor_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IReportCreate
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IReportCreate
     */
    'temperature'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IReportCreate
     */
    'urine_quantity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IReportCreate
     */
    'test_execution_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IReportCreate
     */
    'report_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IReportCreate
     */
    'patient_id'?: string | null;
    /**
     * 
     * @type {IPatientCreate}
     * @memberof IReportCreate
     */
    'patient_create'?: IPatientCreate | null;
}
/**
 * 
 * @export
 * @interface IReportDataOptions
 */
export interface IReportDataOptions {
    /**
     * 
     * @type {boolean}
     * @memberof IReportDataOptions
     */
    'show_comment'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IReportDataOptions
     */
    'show_temperature'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IReportDataOptions
     */
    'show_urine_quantity'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IReportDataOptions
     */
    'show_doctor_name'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IReportDataOptions
     */
    'show_execution_date'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IReportDataOptions
     */
    'show_reporting_date'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IReportDataOptions
     */
    'show_patient_signature'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IReportDataOptions
     */
    'show_doctor_signature'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IReportDataOptions
     */
    'show_times'?: boolean;
}
/**
 * 
 * @export
 * @interface IReportRetryProcessing
 */
export interface IReportRetryProcessing {
    /**
     * 
     * @type {IDrugTestList}
     * @memberof IReportRetryProcessing
     */
    'drug_test_type_override'?: IDrugTestList | null;
}


/**
 * 
 * @export
 * @interface IReportSchema
 */
export interface IReportSchema {
    /**
     * 
     * @type {string}
     * @memberof IReportSchema
     */
    'id': string;
    /**
     * 
     * @type {IReportStatus}
     * @memberof IReportSchema
     */
    'report_status': IReportStatus;
    /**
     * 
     * @type {string}
     * @memberof IReportSchema
     */
    'medical_center_id': string;
    /**
     * 
     * @type {IPatientSchema}
     * @memberof IReportSchema
     */
    'patient': IPatientSchema;
    /**
     * 
     * @type {IDoctorSchema}
     * @memberof IReportSchema
     */
    'doctor'?: IDoctorSchema | null;
    /**
     * 
     * @type {boolean}
     * @memberof IReportSchema
     */
    'has_photo_blister'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IReportSchema
     */
    'has_patient_signature'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IReportSchema
     */
    'has_pdf'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IReportSchema
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IReportSchema
     */
    'temperature'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IReportSchema
     */
    'urine_quantity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IReportSchema
     */
    'test_execution_date': string;
    /**
     * 
     * @type {string}
     * @memberof IReportSchema
     */
    'report_date': string;
    /**
     * 
     * @type {string}
     * @memberof IReportSchema
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof IReportSchema
     */
    'updated_at': string;
    /**
     * 
     * @type {IAnalyzeOutputSchemaOutput}
     * @memberof IReportSchema
     */
    'test_result'?: IAnalyzeOutputSchemaOutput | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const IReportStatus = {
    Draft: 'draft',
    Processed: 'processed',
    Confirmed: 'confirmed',
    Error: 'error'
} as const;

export type IReportStatus = typeof IReportStatus[keyof typeof IReportStatus];


/**
 * 
 * @export
 * @interface IReportSummarySchema
 */
export interface IReportSummarySchema {
    /**
     * 
     * @type {string}
     * @memberof IReportSummarySchema
     */
    'id': string;
    /**
     * 
     * @type {IReportStatus}
     * @memberof IReportSummarySchema
     */
    'report_status': IReportStatus;
    /**
     * 
     * @type {string}
     * @memberof IReportSummarySchema
     */
    'medical_center_id': string;
    /**
     * 
     * @type {IPatientSchema}
     * @memberof IReportSummarySchema
     */
    'patient': IPatientSchema;
    /**
     * 
     * @type {IDoctorSchema}
     * @memberof IReportSummarySchema
     */
    'doctor'?: IDoctorSchema | null;
    /**
     * 
     * @type {boolean}
     * @memberof IReportSummarySchema
     */
    'has_photo_blister'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IReportSummarySchema
     */
    'has_patient_signature'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IReportSummarySchema
     */
    'has_pdf'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IReportSummarySchema
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IReportSummarySchema
     */
    'temperature'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IReportSummarySchema
     */
    'urine_quantity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IReportSummarySchema
     */
    'test_execution_date': string;
    /**
     * 
     * @type {string}
     * @memberof IReportSummarySchema
     */
    'report_date': string;
    /**
     * 
     * @type {string}
     * @memberof IReportSummarySchema
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof IReportSummarySchema
     */
    'updated_at': string;
}


/**
 * 
 * @export
 * @interface IReportUpdate
 */
export interface IReportUpdate {
    /**
     * 
     * @type {string}
     * @memberof IReportUpdate
     */
    'doctor_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IReportUpdate
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IReportUpdate
     */
    'temperature'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IReportUpdate
     */
    'urine_quantity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IReportUpdate
     */
    'test_execution_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IReportUpdate
     */
    'report_date'?: string | null;
    /**
     * 
     * @type {IAnalyzeOutputSchemaInput}
     * @memberof IReportUpdate
     */
    'test_result'?: IAnalyzeOutputSchemaInput | null;
}
/**
 * 
 * @export
 * @interface IResetPasswordRequest
 */
export interface IResetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof IResetPasswordRequest
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof IResetPasswordRequest
     */
    'new_password': string;
}
/**
 * 
 * @export
 * @interface IStatisticsOverviewSchema
 */
export interface IStatisticsOverviewSchema {
    /**
     * 
     * @type {number}
     * @memberof IStatisticsOverviewSchema
     */
    'total_patients': number;
    /**
     * 
     * @type {number}
     * @memberof IStatisticsOverviewSchema
     */
    'active_doctors': number;
    /**
     * 
     * @type {number}
     * @memberof IStatisticsOverviewSchema
     */
    'total_reports': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof IStatisticsOverviewSchema
     */
    'reports_by_status': { [key: string]: number; };
    /**
     * 
     * @type {string}
     * @memberof IStatisticsOverviewSchema
     */
    'last_report_date'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ISubstanceName = {
    Amp500: 'amp500',
    Bup10: 'bup10',
    Bup5: 'bup5',
    Coc300: 'coc300',
    Mdma500: 'mdma500',
    Met500: 'met500',
    Mor300: 'mor300',
    Mtd300: 'mtd300',
    Tetanus: 'tetanus',
    Thc50: 'thc50'
} as const;

export type ISubstanceName = typeof ISubstanceName[keyof typeof ISubstanceName];


/**
 * 
 * @export
 * @enum {string}
 */

export const ISubstanceOutcome = {
    Invalid: 'invalid',
    Negative: 'negative',
    Positive: 'positive',
    Unset: 'unset',
    Cutoff: 'cutoff'
} as const;

export type ISubstanceOutcome = typeof ISubstanceOutcome[keyof typeof ISubstanceOutcome];


/**
 * 
 * @export
 * @interface ISubstanceResult
 */
export interface ISubstanceResult {
    /**
     * 
     * @type {ISubstanceName}
     * @memberof ISubstanceResult
     */
    'name': ISubstanceName;
    /**
     * 
     * @type {ISubstanceOutcome}
     * @memberof ISubstanceResult
     */
    'outcome': ISubstanceOutcome;
}


/**
 * 
 * @export
 * @interface IToken
 */
export interface IToken {
    /**
     * 
     * @type {string}
     * @memberof IToken
     */
    'access_token': string;
    /**
     * 
     * @type {string}
     * @memberof IToken
     */
    'refresh_token'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IToken
     */
    'token_type'?: string | null;
}
/**
 * 
 * @export
 * @interface IUserCreate
 */
export interface IUserCreate {
    /**
     * 
     * @type {string}
     * @memberof IUserCreate
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IUserCreate
     */
    'is_active'?: boolean | null;
    /**
     * 
     * @type {IUserRole}
     * @memberof IUserCreate
     */
    'role'?: IUserRole;
    /**
     * 
     * @type {string}
     * @memberof IUserCreate
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IUserCreate
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {IUserLanguage}
     * @memberof IUserCreate
     */
    'language'?: IUserLanguage | null;
    /**
     * 
     * @type {string}
     * @memberof IUserCreate
     */
    'password'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const IUserLanguage = {
    De: 'de',
    En: 'en',
    Es: 'es',
    Fr: 'fr',
    It: 'it'
} as const;

export type IUserLanguage = typeof IUserLanguage[keyof typeof IUserLanguage];


/**
 * 
 * @export
 * @enum {string}
 */

export const IUserRole = {
    Admin: 'admin',
    MedicalCenter: 'medical_center'
} as const;

export type IUserRole = typeof IUserRole[keyof typeof IUserRole];


/**
 * 
 * @export
 * @interface IUserSchema
 */
export interface IUserSchema {
    /**
     * 
     * @type {string}
     * @memberof IUserSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof IUserSchema
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof IUserSchema
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof IUserSchema
     */
    'email': string;
    /**
     * 
     * @type {IUserRole}
     * @memberof IUserSchema
     */
    'role': IUserRole;
    /**
     * 
     * @type {boolean}
     * @memberof IUserSchema
     */
    'is_active': boolean;
    /**
     * 
     * @type {string}
     * @memberof IUserSchema
     */
    'medical_center_id'?: string | null;
    /**
     * 
     * @type {IUserLanguage}
     * @memberof IUserSchema
     */
    'language': IUserLanguage;
    /**
     * 
     * @type {string}
     * @memberof IUserSchema
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof IUserSchema
     */
    'updated_at': string;
}


/**
 * 
 * @export
 * @interface IValidationError
 */
export interface IValidationError {
    /**
     * 
     * @type {Array<IValidationErrorLocInner>}
     * @memberof IValidationError
     */
    'loc': Array<IValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof IValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof IValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface IValidationErrorLocInner
 */
export interface IValidationErrorLocInner {
}

/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Change password for logged-in user
         * @summary Change-Password
         * @param {IChangePasswordRequest} iChangePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (iChangePasswordRequest: IChangePasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iChangePasswordRequest' is not null or undefined
            assertParamExists('changePassword', 'iChangePasswordRequest', iChangePasswordRequest)
            const localVarPath = `/be/api/v1/auth/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iChangePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send password reset link to user email
         * @summary Forgot-Password
         * @param {IForgotPasswordRequest} iForgotPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: async (iForgotPasswordRequest: IForgotPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iForgotPasswordRequest' is not null or undefined
            assertParamExists('forgotPassword', 'iForgotPasswordRequest', iForgotPasswordRequest)
            const localVarPath = `/be/api/v1/auth/forgot-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iForgotPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User login
         * @summary Get-Access-Token
         * @param {string} username 
         * @param {string} password 
         * @param {string | null} [grantType] 
         * @param {string} [scope] 
         * @param {string | null} [clientId] 
         * @param {string | null} [clientSecret] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessToken: async (username: string, password: string, grantType?: string | null, scope?: string, clientId?: string | null, clientSecret?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getAccessToken', 'username', username)
            // verify required parameter 'password' is not null or undefined
            assertParamExists('getAccessToken', 'password', password)
            const localVarPath = `/be/api/v1/auth/login/access-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (grantType !== undefined) { 
                localVarFormParams.set('grant_type', grantType as any);
            }
    
            if (username !== undefined) { 
                localVarFormParams.set('username', username as any);
            }
    
            if (password !== undefined) { 
                localVarFormParams.set('password', password as any);
            }
    
            if (scope !== undefined) { 
                localVarFormParams.set('scope', scope as any);
            }
    
            if (clientId !== undefined) { 
                localVarFormParams.set('client_id', clientId as any);
            }
    
            if (clientSecret !== undefined) { 
                localVarFormParams.set('client_secret', clientSecret as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the current logged user information
         * @summary Get-Current-Auth-User-Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAuthUserDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/be/api/v1/auth/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refresh access token using refresh token
         * @summary Refresh-Access-Token
         * @param {IRefreshTokenRequest} iRefreshTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshAccessToken: async (iRefreshTokenRequest: IRefreshTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iRefreshTokenRequest' is not null or undefined
            assertParamExists('refreshAccessToken', 'iRefreshTokenRequest', iRefreshTokenRequest)
            const localVarPath = `/be/api/v1/auth/login/refresh-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iRefreshTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reset user password with valid reset token
         * @summary Reset-Password
         * @param {IResetPasswordRequest} iResetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (iResetPasswordRequest: IResetPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iResetPasswordRequest' is not null or undefined
            assertParamExists('resetPassword', 'iResetPasswordRequest', iResetPasswordRequest)
            const localVarPath = `/be/api/v1/auth/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iResetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * Change password for logged-in user
         * @summary Change-Password
         * @param {IChangePasswordRequest} iChangePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(iChangePasswordRequest: IChangePasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword(iChangePasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.changePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send password reset link to user email
         * @summary Forgot-Password
         * @param {IForgotPasswordRequest} iForgotPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forgotPassword(iForgotPasswordRequest: IForgotPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forgotPassword(iForgotPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.forgotPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * User login
         * @summary Get-Access-Token
         * @param {string} username 
         * @param {string} password 
         * @param {string | null} [grantType] 
         * @param {string} [scope] 
         * @param {string | null} [clientId] 
         * @param {string | null} [clientSecret] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessToken(username: string, password: string, grantType?: string | null, scope?: string, clientId?: string | null, clientSecret?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccessToken(username, password, grantType, scope, clientId, clientSecret, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.getAccessToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the current logged user information
         * @summary Get-Current-Auth-User-Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentAuthUserDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IUserSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentAuthUserDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.getCurrentAuthUserDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Refresh access token using refresh token
         * @summary Refresh-Access-Token
         * @param {IRefreshTokenRequest} iRefreshTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshAccessToken(iRefreshTokenRequest: IRefreshTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshAccessToken(iRefreshTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.refreshAccessToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reset user password with valid reset token
         * @summary Reset-Password
         * @param {IResetPasswordRequest} iResetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(iResetPasswordRequest: IResetPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(iResetPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.resetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * Change password for logged-in user
         * @summary Change-Password
         * @param {IChangePasswordRequest} iChangePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(iChangePasswordRequest: IChangePasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.changePassword(iChangePasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Send password reset link to user email
         * @summary Forgot-Password
         * @param {IForgotPasswordRequest} iForgotPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword(iForgotPasswordRequest: IForgotPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.forgotPassword(iForgotPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * User login
         * @summary Get-Access-Token
         * @param {string} username 
         * @param {string} password 
         * @param {string | null} [grantType] 
         * @param {string} [scope] 
         * @param {string | null} [clientId] 
         * @param {string | null} [clientSecret] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessToken(username: string, password: string, grantType?: string | null, scope?: string, clientId?: string | null, clientSecret?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<IToken> {
            return localVarFp.getAccessToken(username, password, grantType, scope, clientId, clientSecret, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the current logged user information
         * @summary Get-Current-Auth-User-Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAuthUserDetails(options?: RawAxiosRequestConfig): AxiosPromise<IUserSchema> {
            return localVarFp.getCurrentAuthUserDetails(options).then((request) => request(axios, basePath));
        },
        /**
         * Refresh access token using refresh token
         * @summary Refresh-Access-Token
         * @param {IRefreshTokenRequest} iRefreshTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshAccessToken(iRefreshTokenRequest: IRefreshTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<IToken> {
            return localVarFp.refreshAccessToken(iRefreshTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Reset user password with valid reset token
         * @summary Reset-Password
         * @param {IResetPasswordRequest} iResetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(iResetPasswordRequest: IResetPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.resetPassword(iResetPasswordRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
    /**
     * Change password for logged-in user
     * @summary Change-Password
     * @param {IChangePasswordRequest} iChangePasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public changePassword(iChangePasswordRequest: IChangePasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).changePassword(iChangePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send password reset link to user email
     * @summary Forgot-Password
     * @param {IForgotPasswordRequest} iForgotPasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public forgotPassword(iForgotPasswordRequest: IForgotPasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).forgotPassword(iForgotPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * User login
     * @summary Get-Access-Token
     * @param {string} username 
     * @param {string} password 
     * @param {string | null} [grantType] 
     * @param {string} [scope] 
     * @param {string | null} [clientId] 
     * @param {string | null} [clientSecret] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public getAccessToken(username: string, password: string, grantType?: string | null, scope?: string, clientId?: string | null, clientSecret?: string | null, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).getAccessToken(username, password, grantType, scope, clientId, clientSecret, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the current logged user information
     * @summary Get-Current-Auth-User-Details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public getCurrentAuthUserDetails(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).getCurrentAuthUserDetails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Refresh access token using refresh token
     * @summary Refresh-Access-Token
     * @param {IRefreshTokenRequest} iRefreshTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public refreshAccessToken(iRefreshTokenRequest: IRefreshTokenRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).refreshAccessToken(iRefreshTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reset user password with valid reset token
     * @summary Reset-Password
     * @param {IResetPasswordRequest} iResetPasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public resetPassword(iResetPasswordRequest: IResetPasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).resetPassword(iResetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Server health status check
         * @summary Health-Check-Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/be/health/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration)
    return {
        /**
         * Server health status check
         * @summary Health-Check-Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheckStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.healthCheckStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthApiFp(configuration)
    return {
        /**
         * Server health status check
         * @summary Health-Check-Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckStatus(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.healthCheckStatus(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
    /**
     * Server health status check
     * @summary Health-Check-Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public healthCheckStatus(options?: RawAxiosRequestConfig) {
        return HealthApiFp(this.configuration).healthCheckStatus(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MobileCompaniesApi - axios parameter creator
 * @export
 */
export const MobileCompaniesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new company
         * @summary Mobile-Create-Company
         * @param {ICompanyCreate} iCompanyCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileCreateCompany: async (iCompanyCreate: ICompanyCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iCompanyCreate' is not null or undefined
            assertParamExists('mobileCreateCompany', 'iCompanyCreate', iCompanyCreate)
            const localVarPath = `/be/api/v1/app/companies/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iCompanyCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a company
         * @summary Mobile-Delete-Company
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileDeleteCompany: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('mobileDeleteCompany', 'companyId', companyId)
            const localVarPath = `/be/api/v1/app/companies/{company_id}`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get company details
         * @summary Mobile-Get-Company-Details
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileGetCompanyDetails: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('mobileGetCompanyDetails', 'companyId', companyId)
            const localVarPath = `/be/api/v1/app/companies/{company_id}`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get full list of companies
         * @summary Mobile-List-Companies
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileListCompanies: async (search?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/be/api/v1/app/companies/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated list of companies
         * @summary Mobile-Paginate-Companies
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobilePaginateCompanies: async (page?: number, size?: number, search?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/be/api/v1/app/companies/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update company information
         * @summary Mobile-Update-Company
         * @param {string} companyId 
         * @param {ICompanyUpdate} iCompanyUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileUpdateCompany: async (companyId: string, iCompanyUpdate: ICompanyUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('mobileUpdateCompany', 'companyId', companyId)
            // verify required parameter 'iCompanyUpdate' is not null or undefined
            assertParamExists('mobileUpdateCompany', 'iCompanyUpdate', iCompanyUpdate)
            const localVarPath = `/be/api/v1/app/companies/{company_id}`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iCompanyUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MobileCompaniesApi - functional programming interface
 * @export
 */
export const MobileCompaniesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MobileCompaniesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new company
         * @summary Mobile-Create-Company
         * @param {ICompanyCreate} iCompanyCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileCreateCompany(iCompanyCreate: ICompanyCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ICompanySchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileCreateCompany(iCompanyCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileCompaniesApi.mobileCreateCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a company
         * @summary Mobile-Delete-Company
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileDeleteCompany(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileDeleteCompany(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileCompaniesApi.mobileDeleteCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get company details
         * @summary Mobile-Get-Company-Details
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileGetCompanyDetails(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ICompanySchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileGetCompanyDetails(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileCompaniesApi.mobileGetCompanyDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get full list of companies
         * @summary Mobile-List-Companies
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileListCompanies(search?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ICompanySchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileListCompanies(search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileCompaniesApi.mobileListCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated list of companies
         * @summary Mobile-Paginate-Companies
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobilePaginateCompanies(page?: number, size?: number, search?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPagedResponseSchemaCompanySchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobilePaginateCompanies(page, size, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileCompaniesApi.mobilePaginateCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update company information
         * @summary Mobile-Update-Company
         * @param {string} companyId 
         * @param {ICompanyUpdate} iCompanyUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileUpdateCompany(companyId: string, iCompanyUpdate: ICompanyUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ICompanySchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileUpdateCompany(companyId, iCompanyUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileCompaniesApi.mobileUpdateCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MobileCompaniesApi - factory interface
 * @export
 */
export const MobileCompaniesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MobileCompaniesApiFp(configuration)
    return {
        /**
         * Create a new company
         * @summary Mobile-Create-Company
         * @param {ICompanyCreate} iCompanyCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileCreateCompany(iCompanyCreate: ICompanyCreate, options?: RawAxiosRequestConfig): AxiosPromise<ICompanySchema> {
            return localVarFp.mobileCreateCompany(iCompanyCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a company
         * @summary Mobile-Delete-Company
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileDeleteCompany(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.mobileDeleteCompany(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get company details
         * @summary Mobile-Get-Company-Details
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileGetCompanyDetails(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ICompanySchema> {
            return localVarFp.mobileGetCompanyDetails(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get full list of companies
         * @summary Mobile-List-Companies
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileListCompanies(search?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<ICompanySchema>> {
            return localVarFp.mobileListCompanies(search, options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated list of companies
         * @summary Mobile-Paginate-Companies
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobilePaginateCompanies(page?: number, size?: number, search?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<IPagedResponseSchemaCompanySchema> {
            return localVarFp.mobilePaginateCompanies(page, size, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Update company information
         * @summary Mobile-Update-Company
         * @param {string} companyId 
         * @param {ICompanyUpdate} iCompanyUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileUpdateCompany(companyId: string, iCompanyUpdate: ICompanyUpdate, options?: RawAxiosRequestConfig): AxiosPromise<ICompanySchema> {
            return localVarFp.mobileUpdateCompany(companyId, iCompanyUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MobileCompaniesApi - object-oriented interface
 * @export
 * @class MobileCompaniesApi
 * @extends {BaseAPI}
 */
export class MobileCompaniesApi extends BaseAPI {
    /**
     * Create a new company
     * @summary Mobile-Create-Company
     * @param {ICompanyCreate} iCompanyCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileCompaniesApi
     */
    public mobileCreateCompany(iCompanyCreate: ICompanyCreate, options?: RawAxiosRequestConfig) {
        return MobileCompaniesApiFp(this.configuration).mobileCreateCompany(iCompanyCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a company
     * @summary Mobile-Delete-Company
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileCompaniesApi
     */
    public mobileDeleteCompany(companyId: string, options?: RawAxiosRequestConfig) {
        return MobileCompaniesApiFp(this.configuration).mobileDeleteCompany(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get company details
     * @summary Mobile-Get-Company-Details
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileCompaniesApi
     */
    public mobileGetCompanyDetails(companyId: string, options?: RawAxiosRequestConfig) {
        return MobileCompaniesApiFp(this.configuration).mobileGetCompanyDetails(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get full list of companies
     * @summary Mobile-List-Companies
     * @param {string | null} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileCompaniesApi
     */
    public mobileListCompanies(search?: string | null, options?: RawAxiosRequestConfig) {
        return MobileCompaniesApiFp(this.configuration).mobileListCompanies(search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated list of companies
     * @summary Mobile-Paginate-Companies
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string | null} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileCompaniesApi
     */
    public mobilePaginateCompanies(page?: number, size?: number, search?: string | null, options?: RawAxiosRequestConfig) {
        return MobileCompaniesApiFp(this.configuration).mobilePaginateCompanies(page, size, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update company information
     * @summary Mobile-Update-Company
     * @param {string} companyId 
     * @param {ICompanyUpdate} iCompanyUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileCompaniesApi
     */
    public mobileUpdateCompany(companyId: string, iCompanyUpdate: ICompanyUpdate, options?: RawAxiosRequestConfig) {
        return MobileCompaniesApiFp(this.configuration).mobileUpdateCompany(companyId, iCompanyUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MobileDoctorsApi - axios parameter creator
 * @export
 */
export const MobileDoctorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Activate doctor
         * @summary Mobile-Activate-Doctor
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileActivateDoctor: async (doctorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'doctorId' is not null or undefined
            assertParamExists('mobileActivateDoctor', 'doctorId', doctorId)
            const localVarPath = `/be/api/v1/app/doctors/{doctor_id}/activate`
                .replace(`{${"doctor_id"}}`, encodeURIComponent(String(doctorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new doctor (without signature)
         * @summary Mobile-Create-Doctor
         * @param {IDoctorCreate} iDoctorCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileCreateDoctor: async (iDoctorCreate: IDoctorCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iDoctorCreate' is not null or undefined
            assertParamExists('mobileCreateDoctor', 'iDoctorCreate', iDoctorCreate)
            const localVarPath = `/be/api/v1/app/doctors/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iDoctorCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Dectivate doctor
         * @summary Mobile-Dectivate-Doctor
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileDectivateDoctor: async (doctorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'doctorId' is not null or undefined
            assertParamExists('mobileDectivateDoctor', 'doctorId', doctorId)
            const localVarPath = `/be/api/v1/app/doctors/{doctor_id}/deactivate`
                .replace(`{${"doctor_id"}}`, encodeURIComponent(String(doctorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a doctor
         * @summary Mobile-Delete-Doctor
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileDeleteDoctor: async (doctorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'doctorId' is not null or undefined
            assertParamExists('mobileDeleteDoctor', 'doctorId', doctorId)
            const localVarPath = `/be/api/v1/app/doctors/{doctor_id}`
                .replace(`{${"doctor_id"}}`, encodeURIComponent(String(doctorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download an attachment of a doctor
         * @summary Mobile-Download-Doctor-Attachment
         * @param {IDoctorAttachmentType} attachmentType 
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileDownloadDoctorAttachment: async (attachmentType: IDoctorAttachmentType, doctorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentType' is not null or undefined
            assertParamExists('mobileDownloadDoctorAttachment', 'attachmentType', attachmentType)
            // verify required parameter 'doctorId' is not null or undefined
            assertParamExists('mobileDownloadDoctorAttachment', 'doctorId', doctorId)
            const localVarPath = `/be/api/v1/app/doctors/{doctor_id}/attachment/{attachment_type}`
                .replace(`{${"attachment_type"}}`, encodeURIComponent(String(attachmentType)))
                .replace(`{${"doctor_id"}}`, encodeURIComponent(String(doctorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a doctor by ID
         * @summary Mobile-Get-Doctor-By-Id
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileGetDoctorByID: async (doctorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'doctorId' is not null or undefined
            assertParamExists('mobileGetDoctorByID', 'doctorId', doctorId)
            const localVarPath = `/be/api/v1/app/doctors/{doctor_id}/details`
                .replace(`{${"doctor_id"}}`, encodeURIComponent(String(doctorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get full list of doctors (active doctors only)
         * @summary Mobile-List-Doctors
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileListDoctors: async (search?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/be/api/v1/app/doctors/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated list of doctors (active doctors only)
         * @summary Mobile-Paginate-Doctors
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobilePaginateDoctors: async (page?: number, size?: number, search?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/be/api/v1/app/doctors/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update doctor information
         * @summary Mobile-Update-Doctor
         * @param {string} doctorId 
         * @param {IDoctorUpdate} iDoctorUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileUpdateDoctor: async (doctorId: string, iDoctorUpdate: IDoctorUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'doctorId' is not null or undefined
            assertParamExists('mobileUpdateDoctor', 'doctorId', doctorId)
            // verify required parameter 'iDoctorUpdate' is not null or undefined
            assertParamExists('mobileUpdateDoctor', 'iDoctorUpdate', iDoctorUpdate)
            const localVarPath = `/be/api/v1/app/doctors/{doctor_id}`
                .replace(`{${"doctor_id"}}`, encodeURIComponent(String(doctorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iDoctorUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload an attachment of a doctor
         * @summary Mobile-Upload-Doctor-Attachment
         * @param {IDoctorAttachmentType} attachmentType 
         * @param {string} doctorId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileUploadDoctorAttachment: async (attachmentType: IDoctorAttachmentType, doctorId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentType' is not null or undefined
            assertParamExists('mobileUploadDoctorAttachment', 'attachmentType', attachmentType)
            // verify required parameter 'doctorId' is not null or undefined
            assertParamExists('mobileUploadDoctorAttachment', 'doctorId', doctorId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('mobileUploadDoctorAttachment', 'file', file)
            const localVarPath = `/be/api/v1/app/doctors/{doctor_id}/attachment/{attachment_type}`
                .replace(`{${"attachment_type"}}`, encodeURIComponent(String(attachmentType)))
                .replace(`{${"doctor_id"}}`, encodeURIComponent(String(doctorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MobileDoctorsApi - functional programming interface
 * @export
 */
export const MobileDoctorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MobileDoctorsApiAxiosParamCreator(configuration)
    return {
        /**
         * Activate doctor
         * @summary Mobile-Activate-Doctor
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileActivateDoctor(doctorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IDoctorSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileActivateDoctor(doctorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileDoctorsApi.mobileActivateDoctor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new doctor (without signature)
         * @summary Mobile-Create-Doctor
         * @param {IDoctorCreate} iDoctorCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileCreateDoctor(iDoctorCreate: IDoctorCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IDoctorSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileCreateDoctor(iDoctorCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileDoctorsApi.mobileCreateDoctor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Dectivate doctor
         * @summary Mobile-Dectivate-Doctor
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileDectivateDoctor(doctorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IDoctorSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileDectivateDoctor(doctorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileDoctorsApi.mobileDectivateDoctor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a doctor
         * @summary Mobile-Delete-Doctor
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileDeleteDoctor(doctorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileDeleteDoctor(doctorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileDoctorsApi.mobileDeleteDoctor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download an attachment of a doctor
         * @summary Mobile-Download-Doctor-Attachment
         * @param {IDoctorAttachmentType} attachmentType 
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileDownloadDoctorAttachment(attachmentType: IDoctorAttachmentType, doctorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileDownloadDoctorAttachment(attachmentType, doctorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileDoctorsApi.mobileDownloadDoctorAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a doctor by ID
         * @summary Mobile-Get-Doctor-By-Id
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileGetDoctorByID(doctorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IDoctorSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileGetDoctorByID(doctorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileDoctorsApi.mobileGetDoctorByID']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get full list of doctors (active doctors only)
         * @summary Mobile-List-Doctors
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileListDoctors(search?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IDoctorSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileListDoctors(search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileDoctorsApi.mobileListDoctors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated list of doctors (active doctors only)
         * @summary Mobile-Paginate-Doctors
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobilePaginateDoctors(page?: number, size?: number, search?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPagedResponseSchemaDoctorSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobilePaginateDoctors(page, size, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileDoctorsApi.mobilePaginateDoctors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update doctor information
         * @summary Mobile-Update-Doctor
         * @param {string} doctorId 
         * @param {IDoctorUpdate} iDoctorUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileUpdateDoctor(doctorId: string, iDoctorUpdate: IDoctorUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IDoctorSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileUpdateDoctor(doctorId, iDoctorUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileDoctorsApi.mobileUpdateDoctor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload an attachment of a doctor
         * @summary Mobile-Upload-Doctor-Attachment
         * @param {IDoctorAttachmentType} attachmentType 
         * @param {string} doctorId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileUploadDoctorAttachment(attachmentType: IDoctorAttachmentType, doctorId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IDoctorSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileUploadDoctorAttachment(attachmentType, doctorId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileDoctorsApi.mobileUploadDoctorAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MobileDoctorsApi - factory interface
 * @export
 */
export const MobileDoctorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MobileDoctorsApiFp(configuration)
    return {
        /**
         * Activate doctor
         * @summary Mobile-Activate-Doctor
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileActivateDoctor(doctorId: string, options?: RawAxiosRequestConfig): AxiosPromise<IDoctorSchema> {
            return localVarFp.mobileActivateDoctor(doctorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new doctor (without signature)
         * @summary Mobile-Create-Doctor
         * @param {IDoctorCreate} iDoctorCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileCreateDoctor(iDoctorCreate: IDoctorCreate, options?: RawAxiosRequestConfig): AxiosPromise<IDoctorSchema> {
            return localVarFp.mobileCreateDoctor(iDoctorCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Dectivate doctor
         * @summary Mobile-Dectivate-Doctor
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileDectivateDoctor(doctorId: string, options?: RawAxiosRequestConfig): AxiosPromise<IDoctorSchema> {
            return localVarFp.mobileDectivateDoctor(doctorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a doctor
         * @summary Mobile-Delete-Doctor
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileDeleteDoctor(doctorId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.mobileDeleteDoctor(doctorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Download an attachment of a doctor
         * @summary Mobile-Download-Doctor-Attachment
         * @param {IDoctorAttachmentType} attachmentType 
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileDownloadDoctorAttachment(attachmentType: IDoctorAttachmentType, doctorId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.mobileDownloadDoctorAttachment(attachmentType, doctorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a doctor by ID
         * @summary Mobile-Get-Doctor-By-Id
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileGetDoctorByID(doctorId: string, options?: RawAxiosRequestConfig): AxiosPromise<IDoctorSchema> {
            return localVarFp.mobileGetDoctorByID(doctorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get full list of doctors (active doctors only)
         * @summary Mobile-List-Doctors
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileListDoctors(search?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<IDoctorSchema>> {
            return localVarFp.mobileListDoctors(search, options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated list of doctors (active doctors only)
         * @summary Mobile-Paginate-Doctors
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobilePaginateDoctors(page?: number, size?: number, search?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<IPagedResponseSchemaDoctorSchema> {
            return localVarFp.mobilePaginateDoctors(page, size, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Update doctor information
         * @summary Mobile-Update-Doctor
         * @param {string} doctorId 
         * @param {IDoctorUpdate} iDoctorUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileUpdateDoctor(doctorId: string, iDoctorUpdate: IDoctorUpdate, options?: RawAxiosRequestConfig): AxiosPromise<IDoctorSchema> {
            return localVarFp.mobileUpdateDoctor(doctorId, iDoctorUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload an attachment of a doctor
         * @summary Mobile-Upload-Doctor-Attachment
         * @param {IDoctorAttachmentType} attachmentType 
         * @param {string} doctorId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileUploadDoctorAttachment(attachmentType: IDoctorAttachmentType, doctorId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<IDoctorSchema> {
            return localVarFp.mobileUploadDoctorAttachment(attachmentType, doctorId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MobileDoctorsApi - object-oriented interface
 * @export
 * @class MobileDoctorsApi
 * @extends {BaseAPI}
 */
export class MobileDoctorsApi extends BaseAPI {
    /**
     * Activate doctor
     * @summary Mobile-Activate-Doctor
     * @param {string} doctorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileDoctorsApi
     */
    public mobileActivateDoctor(doctorId: string, options?: RawAxiosRequestConfig) {
        return MobileDoctorsApiFp(this.configuration).mobileActivateDoctor(doctorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new doctor (without signature)
     * @summary Mobile-Create-Doctor
     * @param {IDoctorCreate} iDoctorCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileDoctorsApi
     */
    public mobileCreateDoctor(iDoctorCreate: IDoctorCreate, options?: RawAxiosRequestConfig) {
        return MobileDoctorsApiFp(this.configuration).mobileCreateDoctor(iDoctorCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Dectivate doctor
     * @summary Mobile-Dectivate-Doctor
     * @param {string} doctorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileDoctorsApi
     */
    public mobileDectivateDoctor(doctorId: string, options?: RawAxiosRequestConfig) {
        return MobileDoctorsApiFp(this.configuration).mobileDectivateDoctor(doctorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a doctor
     * @summary Mobile-Delete-Doctor
     * @param {string} doctorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileDoctorsApi
     */
    public mobileDeleteDoctor(doctorId: string, options?: RawAxiosRequestConfig) {
        return MobileDoctorsApiFp(this.configuration).mobileDeleteDoctor(doctorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download an attachment of a doctor
     * @summary Mobile-Download-Doctor-Attachment
     * @param {IDoctorAttachmentType} attachmentType 
     * @param {string} doctorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileDoctorsApi
     */
    public mobileDownloadDoctorAttachment(attachmentType: IDoctorAttachmentType, doctorId: string, options?: RawAxiosRequestConfig) {
        return MobileDoctorsApiFp(this.configuration).mobileDownloadDoctorAttachment(attachmentType, doctorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a doctor by ID
     * @summary Mobile-Get-Doctor-By-Id
     * @param {string} doctorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileDoctorsApi
     */
    public mobileGetDoctorByID(doctorId: string, options?: RawAxiosRequestConfig) {
        return MobileDoctorsApiFp(this.configuration).mobileGetDoctorByID(doctorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get full list of doctors (active doctors only)
     * @summary Mobile-List-Doctors
     * @param {string | null} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileDoctorsApi
     */
    public mobileListDoctors(search?: string | null, options?: RawAxiosRequestConfig) {
        return MobileDoctorsApiFp(this.configuration).mobileListDoctors(search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated list of doctors (active doctors only)
     * @summary Mobile-Paginate-Doctors
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string | null} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileDoctorsApi
     */
    public mobilePaginateDoctors(page?: number, size?: number, search?: string | null, options?: RawAxiosRequestConfig) {
        return MobileDoctorsApiFp(this.configuration).mobilePaginateDoctors(page, size, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update doctor information
     * @summary Mobile-Update-Doctor
     * @param {string} doctorId 
     * @param {IDoctorUpdate} iDoctorUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileDoctorsApi
     */
    public mobileUpdateDoctor(doctorId: string, iDoctorUpdate: IDoctorUpdate, options?: RawAxiosRequestConfig) {
        return MobileDoctorsApiFp(this.configuration).mobileUpdateDoctor(doctorId, iDoctorUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload an attachment of a doctor
     * @summary Mobile-Upload-Doctor-Attachment
     * @param {IDoctorAttachmentType} attachmentType 
     * @param {string} doctorId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileDoctorsApi
     */
    public mobileUploadDoctorAttachment(attachmentType: IDoctorAttachmentType, doctorId: string, file: File, options?: RawAxiosRequestConfig) {
        return MobileDoctorsApiFp(this.configuration).mobileUploadDoctorAttachment(attachmentType, doctorId, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MobileMedicalCentersApi - axios parameter creator
 * @export
 */
export const MobileMedicalCentersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get current medical center details
         * @summary Mobile-Get-Current-Medical-Center-Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileGetCurrentMedicalCenterDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/be/api/v1/app/medical-centers/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update current logged in medical center
         * @summary Mobile-Update-Current-Medical-Center
         * @param {ICurrentMedicalCenterUpdate} iCurrentMedicalCenterUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileUpdateCurrentMedicalCenter: async (iCurrentMedicalCenterUpdate: ICurrentMedicalCenterUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iCurrentMedicalCenterUpdate' is not null or undefined
            assertParamExists('mobileUpdateCurrentMedicalCenter', 'iCurrentMedicalCenterUpdate', iCurrentMedicalCenterUpdate)
            const localVarPath = `/be/api/v1/app/medical-centers/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iCurrentMedicalCenterUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MobileMedicalCentersApi - functional programming interface
 * @export
 */
export const MobileMedicalCentersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MobileMedicalCentersApiAxiosParamCreator(configuration)
    return {
        /**
         * Get current medical center details
         * @summary Mobile-Get-Current-Medical-Center-Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileGetCurrentMedicalCenterDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IMedicalCenterSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileGetCurrentMedicalCenterDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileMedicalCentersApi.mobileGetCurrentMedicalCenterDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update current logged in medical center
         * @summary Mobile-Update-Current-Medical-Center
         * @param {ICurrentMedicalCenterUpdate} iCurrentMedicalCenterUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileUpdateCurrentMedicalCenter(iCurrentMedicalCenterUpdate: ICurrentMedicalCenterUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IMedicalCenterSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileUpdateCurrentMedicalCenter(iCurrentMedicalCenterUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileMedicalCentersApi.mobileUpdateCurrentMedicalCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MobileMedicalCentersApi - factory interface
 * @export
 */
export const MobileMedicalCentersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MobileMedicalCentersApiFp(configuration)
    return {
        /**
         * Get current medical center details
         * @summary Mobile-Get-Current-Medical-Center-Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileGetCurrentMedicalCenterDetails(options?: RawAxiosRequestConfig): AxiosPromise<IMedicalCenterSchema> {
            return localVarFp.mobileGetCurrentMedicalCenterDetails(options).then((request) => request(axios, basePath));
        },
        /**
         * Update current logged in medical center
         * @summary Mobile-Update-Current-Medical-Center
         * @param {ICurrentMedicalCenterUpdate} iCurrentMedicalCenterUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileUpdateCurrentMedicalCenter(iCurrentMedicalCenterUpdate: ICurrentMedicalCenterUpdate, options?: RawAxiosRequestConfig): AxiosPromise<IMedicalCenterSchema> {
            return localVarFp.mobileUpdateCurrentMedicalCenter(iCurrentMedicalCenterUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MobileMedicalCentersApi - object-oriented interface
 * @export
 * @class MobileMedicalCentersApi
 * @extends {BaseAPI}
 */
export class MobileMedicalCentersApi extends BaseAPI {
    /**
     * Get current medical center details
     * @summary Mobile-Get-Current-Medical-Center-Details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileMedicalCentersApi
     */
    public mobileGetCurrentMedicalCenterDetails(options?: RawAxiosRequestConfig) {
        return MobileMedicalCentersApiFp(this.configuration).mobileGetCurrentMedicalCenterDetails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update current logged in medical center
     * @summary Mobile-Update-Current-Medical-Center
     * @param {ICurrentMedicalCenterUpdate} iCurrentMedicalCenterUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileMedicalCentersApi
     */
    public mobileUpdateCurrentMedicalCenter(iCurrentMedicalCenterUpdate: ICurrentMedicalCenterUpdate, options?: RawAxiosRequestConfig) {
        return MobileMedicalCentersApiFp(this.configuration).mobileUpdateCurrentMedicalCenter(iCurrentMedicalCenterUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MobilePatientsApi - axios parameter creator
 * @export
 */
export const MobilePatientsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new patient
         * @summary Mobile-Create-Patient
         * @param {IPatientCreate} iPatientCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileCreatePatient: async (iPatientCreate: IPatientCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iPatientCreate' is not null or undefined
            assertParamExists('mobileCreatePatient', 'iPatientCreate', iPatientCreate)
            const localVarPath = `/be/api/v1/app/patients/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iPatientCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a patient
         * @summary Mobile-Delete-Patient
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileDeletePatient: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('mobileDeletePatient', 'patientId', patientId)
            const localVarPath = `/be/api/v1/app/patients/{patient_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get patient details
         * @summary Mobile-Get-Patient-Details
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileGetPatientDetails: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('mobileGetPatientDetails', 'patientId', patientId)
            const localVarPath = `/be/api/v1/app/patients/{patient_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk import patients from CSV file
         * @summary Mobile-Import-Patients-Csv
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileImportPatientsCSV: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('mobileImportPatientsCSV', 'file', file)
            const localVarPath = `/be/api/v1/app/patients/import-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get full list of patients
         * @summary Mobile-List-Patients
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileListPatients: async (search?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/be/api/v1/app/patients/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated list of patients
         * @summary Mobile-Paginate-Patients
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobilePaginatePatients: async (page?: number, size?: number, search?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/be/api/v1/app/patients/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update patient information
         * @summary Mobile-Update-Patient
         * @param {string} patientId 
         * @param {IPatientUpdate} iPatientUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileUpdatePatient: async (patientId: string, iPatientUpdate: IPatientUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('mobileUpdatePatient', 'patientId', patientId)
            // verify required parameter 'iPatientUpdate' is not null or undefined
            assertParamExists('mobileUpdatePatient', 'iPatientUpdate', iPatientUpdate)
            const localVarPath = `/be/api/v1/app/patients/{patient_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iPatientUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MobilePatientsApi - functional programming interface
 * @export
 */
export const MobilePatientsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MobilePatientsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new patient
         * @summary Mobile-Create-Patient
         * @param {IPatientCreate} iPatientCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileCreatePatient(iPatientCreate: IPatientCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPatientSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileCreatePatient(iPatientCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobilePatientsApi.mobileCreatePatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a patient
         * @summary Mobile-Delete-Patient
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileDeletePatient(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileDeletePatient(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobilePatientsApi.mobileDeletePatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get patient details
         * @summary Mobile-Get-Patient-Details
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileGetPatientDetails(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPatientSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileGetPatientDetails(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobilePatientsApi.mobileGetPatientDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bulk import patients from CSV file
         * @summary Mobile-Import-Patients-Csv
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileImportPatientsCSV(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileImportPatientsCSV(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobilePatientsApi.mobileImportPatientsCSV']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get full list of patients
         * @summary Mobile-List-Patients
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileListPatients(search?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IPatientSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileListPatients(search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobilePatientsApi.mobileListPatients']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated list of patients
         * @summary Mobile-Paginate-Patients
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobilePaginatePatients(page?: number, size?: number, search?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPagedResponseSchemaPatientSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobilePaginatePatients(page, size, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobilePatientsApi.mobilePaginatePatients']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update patient information
         * @summary Mobile-Update-Patient
         * @param {string} patientId 
         * @param {IPatientUpdate} iPatientUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileUpdatePatient(patientId: string, iPatientUpdate: IPatientUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPatientSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileUpdatePatient(patientId, iPatientUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobilePatientsApi.mobileUpdatePatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MobilePatientsApi - factory interface
 * @export
 */
export const MobilePatientsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MobilePatientsApiFp(configuration)
    return {
        /**
         * Create a new patient
         * @summary Mobile-Create-Patient
         * @param {IPatientCreate} iPatientCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileCreatePatient(iPatientCreate: IPatientCreate, options?: RawAxiosRequestConfig): AxiosPromise<IPatientSchema> {
            return localVarFp.mobileCreatePatient(iPatientCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a patient
         * @summary Mobile-Delete-Patient
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileDeletePatient(patientId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.mobileDeletePatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get patient details
         * @summary Mobile-Get-Patient-Details
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileGetPatientDetails(patientId: string, options?: RawAxiosRequestConfig): AxiosPromise<IPatientSchema> {
            return localVarFp.mobileGetPatientDetails(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk import patients from CSV file
         * @summary Mobile-Import-Patients-Csv
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileImportPatientsCSV(file: File, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.mobileImportPatientsCSV(file, options).then((request) => request(axios, basePath));
        },
        /**
         * Get full list of patients
         * @summary Mobile-List-Patients
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileListPatients(search?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<IPatientSchema>> {
            return localVarFp.mobileListPatients(search, options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated list of patients
         * @summary Mobile-Paginate-Patients
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobilePaginatePatients(page?: number, size?: number, search?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<IPagedResponseSchemaPatientSchema> {
            return localVarFp.mobilePaginatePatients(page, size, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Update patient information
         * @summary Mobile-Update-Patient
         * @param {string} patientId 
         * @param {IPatientUpdate} iPatientUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileUpdatePatient(patientId: string, iPatientUpdate: IPatientUpdate, options?: RawAxiosRequestConfig): AxiosPromise<IPatientSchema> {
            return localVarFp.mobileUpdatePatient(patientId, iPatientUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MobilePatientsApi - object-oriented interface
 * @export
 * @class MobilePatientsApi
 * @extends {BaseAPI}
 */
export class MobilePatientsApi extends BaseAPI {
    /**
     * Create a new patient
     * @summary Mobile-Create-Patient
     * @param {IPatientCreate} iPatientCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobilePatientsApi
     */
    public mobileCreatePatient(iPatientCreate: IPatientCreate, options?: RawAxiosRequestConfig) {
        return MobilePatientsApiFp(this.configuration).mobileCreatePatient(iPatientCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a patient
     * @summary Mobile-Delete-Patient
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobilePatientsApi
     */
    public mobileDeletePatient(patientId: string, options?: RawAxiosRequestConfig) {
        return MobilePatientsApiFp(this.configuration).mobileDeletePatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get patient details
     * @summary Mobile-Get-Patient-Details
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobilePatientsApi
     */
    public mobileGetPatientDetails(patientId: string, options?: RawAxiosRequestConfig) {
        return MobilePatientsApiFp(this.configuration).mobileGetPatientDetails(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk import patients from CSV file
     * @summary Mobile-Import-Patients-Csv
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobilePatientsApi
     */
    public mobileImportPatientsCSV(file: File, options?: RawAxiosRequestConfig) {
        return MobilePatientsApiFp(this.configuration).mobileImportPatientsCSV(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get full list of patients
     * @summary Mobile-List-Patients
     * @param {string | null} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobilePatientsApi
     */
    public mobileListPatients(search?: string | null, options?: RawAxiosRequestConfig) {
        return MobilePatientsApiFp(this.configuration).mobileListPatients(search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated list of patients
     * @summary Mobile-Paginate-Patients
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string | null} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobilePatientsApi
     */
    public mobilePaginatePatients(page?: number, size?: number, search?: string | null, options?: RawAxiosRequestConfig) {
        return MobilePatientsApiFp(this.configuration).mobilePaginatePatients(page, size, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update patient information
     * @summary Mobile-Update-Patient
     * @param {string} patientId 
     * @param {IPatientUpdate} iPatientUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobilePatientsApi
     */
    public mobileUpdatePatient(patientId: string, iPatientUpdate: IPatientUpdate, options?: RawAxiosRequestConfig) {
        return MobilePatientsApiFp(this.configuration).mobileUpdatePatient(patientId, iPatientUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MobileReportsApi - axios parameter creator
 * @export
 */
export const MobileReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Confirm a report
         * @summary Mobile-Confirm-Report
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileConfirmReport: async (reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('mobileConfirmReport', 'reportId', reportId)
            const localVarPath = `/be/api/v1/app/reports/{report_id}/confirm`
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new report (with a new or existing patient)
         * @summary Mobile-Create-Report
         * @param {IReportCreate} iReportCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileCreateReport: async (iReportCreate: IReportCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iReportCreate' is not null or undefined
            assertParamExists('mobileCreateReport', 'iReportCreate', iReportCreate)
            const localVarPath = `/be/api/v1/app/reports/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iReportCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a report
         * @summary Mobile-Delete-Report
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileDeleteReport: async (reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('mobileDeleteReport', 'reportId', reportId)
            const localVarPath = `/be/api/v1/app/reports/{report_id}`
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download an attachment of a report (photo blister or patient signature)
         * @summary Mobile-Download-Report-Attachment
         * @param {IReportAttachmentType} attachmentType 
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileDownloadReportAttachment: async (attachmentType: IReportAttachmentType, reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentType' is not null or undefined
            assertParamExists('mobileDownloadReportAttachment', 'attachmentType', attachmentType)
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('mobileDownloadReportAttachment', 'reportId', reportId)
            const localVarPath = `/be/api/v1/app/reports/{report_id}/attachment/{attachment_type}`
                .replace(`{${"attachment_type"}}`, encodeURIComponent(String(attachmentType)))
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a structured PDF of a report
         * @summary Mobile-Generate-Report-Pdf
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileGenerateReportPDF: async (reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('mobileGenerateReportPDF', 'reportId', reportId)
            const localVarPath = `/be/api/v1/app/reports/{report_id}/pdf`
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get details of a single report
         * @summary Mobile-Get-Report-Details
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileGetReportDetails: async (reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('mobileGetReportDetails', 'reportId', reportId)
            const localVarPath = `/be/api/v1/app/reports/{report_id}/details`
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get full list of reports
         * @summary Mobile-List-Reports
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileListReports: async (search?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/be/api/v1/app/reports/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get full list of reports filtered by patient id
         * @summary Mobile-List-Reports-By-Patient-Id
         * @param {string} patientId 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileListReportsByPatientID: async (patientId: string, search?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('mobileListReportsByPatientID', 'patientId', patientId)
            const localVarPath = `/be/api/v1/app/reports/patient/{patient_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated list of reports
         * @summary Mobile-Paginate-Reports
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobilePaginateReports: async (page?: number, size?: number, search?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/be/api/v1/app/reports/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retry report photo blister processing
         * @summary Mobile-Retry-Report-Photo-Blister-Processing
         * @param {string} reportId 
         * @param {IReportRetryProcessing} iReportRetryProcessing 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileRetryReportPhotoBlisterProcessing: async (reportId: string, iReportRetryProcessing: IReportRetryProcessing, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('mobileRetryReportPhotoBlisterProcessing', 'reportId', reportId)
            // verify required parameter 'iReportRetryProcessing' is not null or undefined
            assertParamExists('mobileRetryReportPhotoBlisterProcessing', 'iReportRetryProcessing', iReportRetryProcessing)
            const localVarPath = `/be/api/v1/app/reports/{report_id}/retry-photo-blister-processing`
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iReportRetryProcessing, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a report
         * @summary Mobile-Update-Report
         * @param {string} reportId 
         * @param {IReportUpdate} iReportUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileUpdateReport: async (reportId: string, iReportUpdate: IReportUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('mobileUpdateReport', 'reportId', reportId)
            // verify required parameter 'iReportUpdate' is not null or undefined
            assertParamExists('mobileUpdateReport', 'iReportUpdate', iReportUpdate)
            const localVarPath = `/be/api/v1/app/reports/{report_id}`
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iReportUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload an attachment of a report (photo blister or patient signature)
         * @summary Mobile-Upload-Report-Attachment
         * @param {IReportAttachmentType} attachmentType 
         * @param {string} reportId 
         * @param {File} file 
         * @param {IDrugTestList | null} [drugTestTypeOverride] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileUploadReportAttachment: async (attachmentType: IReportAttachmentType, reportId: string, file: File, drugTestTypeOverride?: IDrugTestList | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentType' is not null or undefined
            assertParamExists('mobileUploadReportAttachment', 'attachmentType', attachmentType)
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('mobileUploadReportAttachment', 'reportId', reportId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('mobileUploadReportAttachment', 'file', file)
            const localVarPath = `/be/api/v1/app/reports/{report_id}/attachment/{attachment_type}`
                .replace(`{${"attachment_type"}}`, encodeURIComponent(String(attachmentType)))
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (drugTestTypeOverride !== undefined) {
                localVarQueryParameter['drug_test_type_override'] = drugTestTypeOverride;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MobileReportsApi - functional programming interface
 * @export
 */
export const MobileReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MobileReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * Confirm a report
         * @summary Mobile-Confirm-Report
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileConfirmReport(reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IReportSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileConfirmReport(reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileReportsApi.mobileConfirmReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new report (with a new or existing patient)
         * @summary Mobile-Create-Report
         * @param {IReportCreate} iReportCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileCreateReport(iReportCreate: IReportCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IReportSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileCreateReport(iReportCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileReportsApi.mobileCreateReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a report
         * @summary Mobile-Delete-Report
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileDeleteReport(reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileDeleteReport(reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileReportsApi.mobileDeleteReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download an attachment of a report (photo blister or patient signature)
         * @summary Mobile-Download-Report-Attachment
         * @param {IReportAttachmentType} attachmentType 
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileDownloadReportAttachment(attachmentType: IReportAttachmentType, reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileDownloadReportAttachment(attachmentType, reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileReportsApi.mobileDownloadReportAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate a structured PDF of a report
         * @summary Mobile-Generate-Report-Pdf
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileGenerateReportPDF(reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileGenerateReportPDF(reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileReportsApi.mobileGenerateReportPDF']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get details of a single report
         * @summary Mobile-Get-Report-Details
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileGetReportDetails(reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IReportSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileGetReportDetails(reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileReportsApi.mobileGetReportDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get full list of reports
         * @summary Mobile-List-Reports
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileListReports(search?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IReportSummarySchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileListReports(search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileReportsApi.mobileListReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get full list of reports filtered by patient id
         * @summary Mobile-List-Reports-By-Patient-Id
         * @param {string} patientId 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileListReportsByPatientID(patientId: string, search?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IReportSummarySchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileListReportsByPatientID(patientId, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileReportsApi.mobileListReportsByPatientID']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated list of reports
         * @summary Mobile-Paginate-Reports
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobilePaginateReports(page?: number, size?: number, search?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPagedResponseSchemaReportSummarySchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobilePaginateReports(page, size, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileReportsApi.mobilePaginateReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retry report photo blister processing
         * @summary Mobile-Retry-Report-Photo-Blister-Processing
         * @param {string} reportId 
         * @param {IReportRetryProcessing} iReportRetryProcessing 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileRetryReportPhotoBlisterProcessing(reportId: string, iReportRetryProcessing: IReportRetryProcessing, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IReportSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileRetryReportPhotoBlisterProcessing(reportId, iReportRetryProcessing, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileReportsApi.mobileRetryReportPhotoBlisterProcessing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a report
         * @summary Mobile-Update-Report
         * @param {string} reportId 
         * @param {IReportUpdate} iReportUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileUpdateReport(reportId: string, iReportUpdate: IReportUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IReportSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileUpdateReport(reportId, iReportUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileReportsApi.mobileUpdateReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload an attachment of a report (photo blister or patient signature)
         * @summary Mobile-Upload-Report-Attachment
         * @param {IReportAttachmentType} attachmentType 
         * @param {string} reportId 
         * @param {File} file 
         * @param {IDrugTestList | null} [drugTestTypeOverride] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileUploadReportAttachment(attachmentType: IReportAttachmentType, reportId: string, file: File, drugTestTypeOverride?: IDrugTestList | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IReportSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileUploadReportAttachment(attachmentType, reportId, file, drugTestTypeOverride, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MobileReportsApi.mobileUploadReportAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MobileReportsApi - factory interface
 * @export
 */
export const MobileReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MobileReportsApiFp(configuration)
    return {
        /**
         * Confirm a report
         * @summary Mobile-Confirm-Report
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileConfirmReport(reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<IReportSchema> {
            return localVarFp.mobileConfirmReport(reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new report (with a new or existing patient)
         * @summary Mobile-Create-Report
         * @param {IReportCreate} iReportCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileCreateReport(iReportCreate: IReportCreate, options?: RawAxiosRequestConfig): AxiosPromise<IReportSchema> {
            return localVarFp.mobileCreateReport(iReportCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a report
         * @summary Mobile-Delete-Report
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileDeleteReport(reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.mobileDeleteReport(reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Download an attachment of a report (photo blister or patient signature)
         * @summary Mobile-Download-Report-Attachment
         * @param {IReportAttachmentType} attachmentType 
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileDownloadReportAttachment(attachmentType: IReportAttachmentType, reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.mobileDownloadReportAttachment(attachmentType, reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a structured PDF of a report
         * @summary Mobile-Generate-Report-Pdf
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileGenerateReportPDF(reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.mobileGenerateReportPDF(reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get details of a single report
         * @summary Mobile-Get-Report-Details
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileGetReportDetails(reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<IReportSchema> {
            return localVarFp.mobileGetReportDetails(reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get full list of reports
         * @summary Mobile-List-Reports
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileListReports(search?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<IReportSummarySchema>> {
            return localVarFp.mobileListReports(search, options).then((request) => request(axios, basePath));
        },
        /**
         * Get full list of reports filtered by patient id
         * @summary Mobile-List-Reports-By-Patient-Id
         * @param {string} patientId 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileListReportsByPatientID(patientId: string, search?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<IReportSummarySchema>> {
            return localVarFp.mobileListReportsByPatientID(patientId, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated list of reports
         * @summary Mobile-Paginate-Reports
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobilePaginateReports(page?: number, size?: number, search?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<IPagedResponseSchemaReportSummarySchema> {
            return localVarFp.mobilePaginateReports(page, size, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Retry report photo blister processing
         * @summary Mobile-Retry-Report-Photo-Blister-Processing
         * @param {string} reportId 
         * @param {IReportRetryProcessing} iReportRetryProcessing 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileRetryReportPhotoBlisterProcessing(reportId: string, iReportRetryProcessing: IReportRetryProcessing, options?: RawAxiosRequestConfig): AxiosPromise<IReportSchema> {
            return localVarFp.mobileRetryReportPhotoBlisterProcessing(reportId, iReportRetryProcessing, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a report
         * @summary Mobile-Update-Report
         * @param {string} reportId 
         * @param {IReportUpdate} iReportUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileUpdateReport(reportId: string, iReportUpdate: IReportUpdate, options?: RawAxiosRequestConfig): AxiosPromise<IReportSchema> {
            return localVarFp.mobileUpdateReport(reportId, iReportUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload an attachment of a report (photo blister or patient signature)
         * @summary Mobile-Upload-Report-Attachment
         * @param {IReportAttachmentType} attachmentType 
         * @param {string} reportId 
         * @param {File} file 
         * @param {IDrugTestList | null} [drugTestTypeOverride] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileUploadReportAttachment(attachmentType: IReportAttachmentType, reportId: string, file: File, drugTestTypeOverride?: IDrugTestList | null, options?: RawAxiosRequestConfig): AxiosPromise<IReportSchema> {
            return localVarFp.mobileUploadReportAttachment(attachmentType, reportId, file, drugTestTypeOverride, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MobileReportsApi - object-oriented interface
 * @export
 * @class MobileReportsApi
 * @extends {BaseAPI}
 */
export class MobileReportsApi extends BaseAPI {
    /**
     * Confirm a report
     * @summary Mobile-Confirm-Report
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileReportsApi
     */
    public mobileConfirmReport(reportId: string, options?: RawAxiosRequestConfig) {
        return MobileReportsApiFp(this.configuration).mobileConfirmReport(reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new report (with a new or existing patient)
     * @summary Mobile-Create-Report
     * @param {IReportCreate} iReportCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileReportsApi
     */
    public mobileCreateReport(iReportCreate: IReportCreate, options?: RawAxiosRequestConfig) {
        return MobileReportsApiFp(this.configuration).mobileCreateReport(iReportCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a report
     * @summary Mobile-Delete-Report
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileReportsApi
     */
    public mobileDeleteReport(reportId: string, options?: RawAxiosRequestConfig) {
        return MobileReportsApiFp(this.configuration).mobileDeleteReport(reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download an attachment of a report (photo blister or patient signature)
     * @summary Mobile-Download-Report-Attachment
     * @param {IReportAttachmentType} attachmentType 
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileReportsApi
     */
    public mobileDownloadReportAttachment(attachmentType: IReportAttachmentType, reportId: string, options?: RawAxiosRequestConfig) {
        return MobileReportsApiFp(this.configuration).mobileDownloadReportAttachment(attachmentType, reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate a structured PDF of a report
     * @summary Mobile-Generate-Report-Pdf
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileReportsApi
     */
    public mobileGenerateReportPDF(reportId: string, options?: RawAxiosRequestConfig) {
        return MobileReportsApiFp(this.configuration).mobileGenerateReportPDF(reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get details of a single report
     * @summary Mobile-Get-Report-Details
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileReportsApi
     */
    public mobileGetReportDetails(reportId: string, options?: RawAxiosRequestConfig) {
        return MobileReportsApiFp(this.configuration).mobileGetReportDetails(reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get full list of reports
     * @summary Mobile-List-Reports
     * @param {string | null} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileReportsApi
     */
    public mobileListReports(search?: string | null, options?: RawAxiosRequestConfig) {
        return MobileReportsApiFp(this.configuration).mobileListReports(search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get full list of reports filtered by patient id
     * @summary Mobile-List-Reports-By-Patient-Id
     * @param {string} patientId 
     * @param {string | null} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileReportsApi
     */
    public mobileListReportsByPatientID(patientId: string, search?: string | null, options?: RawAxiosRequestConfig) {
        return MobileReportsApiFp(this.configuration).mobileListReportsByPatientID(patientId, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated list of reports
     * @summary Mobile-Paginate-Reports
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string | null} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileReportsApi
     */
    public mobilePaginateReports(page?: number, size?: number, search?: string | null, options?: RawAxiosRequestConfig) {
        return MobileReportsApiFp(this.configuration).mobilePaginateReports(page, size, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retry report photo blister processing
     * @summary Mobile-Retry-Report-Photo-Blister-Processing
     * @param {string} reportId 
     * @param {IReportRetryProcessing} iReportRetryProcessing 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileReportsApi
     */
    public mobileRetryReportPhotoBlisterProcessing(reportId: string, iReportRetryProcessing: IReportRetryProcessing, options?: RawAxiosRequestConfig) {
        return MobileReportsApiFp(this.configuration).mobileRetryReportPhotoBlisterProcessing(reportId, iReportRetryProcessing, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a report
     * @summary Mobile-Update-Report
     * @param {string} reportId 
     * @param {IReportUpdate} iReportUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileReportsApi
     */
    public mobileUpdateReport(reportId: string, iReportUpdate: IReportUpdate, options?: RawAxiosRequestConfig) {
        return MobileReportsApiFp(this.configuration).mobileUpdateReport(reportId, iReportUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload an attachment of a report (photo blister or patient signature)
     * @summary Mobile-Upload-Report-Attachment
     * @param {IReportAttachmentType} attachmentType 
     * @param {string} reportId 
     * @param {File} file 
     * @param {IDrugTestList | null} [drugTestTypeOverride] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileReportsApi
     */
    public mobileUploadReportAttachment(attachmentType: IReportAttachmentType, reportId: string, file: File, drugTestTypeOverride?: IDrugTestList | null, options?: RawAxiosRequestConfig) {
        return MobileReportsApiFp(this.configuration).mobileUploadReportAttachment(attachmentType, reportId, file, drugTestTypeOverride, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WebAdminMedicalCentersApi - axios parameter creator
 * @export
 */
export const WebAdminMedicalCentersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API to activate a medical center
         * @summary Admin-Activate-Medical-Center
         * @param {string} medicalCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminActivateMedicalCenter: async (medicalCenterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'medicalCenterId' is not null or undefined
            assertParamExists('adminActivateMedicalCenter', 'medicalCenterId', medicalCenterId)
            const localVarPath = `/be/api/v1/admin/medical-centers/{medical_center_id}/activate`
                .replace(`{${"medical_center_id"}}`, encodeURIComponent(String(medicalCenterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to deactivate a medical center
         * @summary Admin-Deactivate-Medical-Center
         * @param {string} medicalCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDectivateMedicalCenter: async (medicalCenterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'medicalCenterId' is not null or undefined
            assertParamExists('adminDectivateMedicalCenter', 'medicalCenterId', medicalCenterId)
            const localVarPath = `/be/api/v1/admin/medical-centers/{medical_center_id}/deactivate`
                .replace(`{${"medical_center_id"}}`, encodeURIComponent(String(medicalCenterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a medical center
         * @summary Admin-Delete-Medical-Center
         * @param {string} medicalCenterId 
         * @param {IMedicalCenterDeleteSchema} iMedicalCenterDeleteSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteMedicalCenter: async (medicalCenterId: string, iMedicalCenterDeleteSchema: IMedicalCenterDeleteSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'medicalCenterId' is not null or undefined
            assertParamExists('adminDeleteMedicalCenter', 'medicalCenterId', medicalCenterId)
            // verify required parameter 'iMedicalCenterDeleteSchema' is not null or undefined
            assertParamExists('adminDeleteMedicalCenter', 'iMedicalCenterDeleteSchema', iMedicalCenterDeleteSchema)
            const localVarPath = `/be/api/v1/admin/medical-centers/{medical_center_id}`
                .replace(`{${"medical_center_id"}}`, encodeURIComponent(String(medicalCenterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iMedicalCenterDeleteSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a medical center by ID
         * @summary Admin-Get-Medical-Center-By-Id
         * @param {string} medicalCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetMedicalCenterByID: async (medicalCenterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'medicalCenterId' is not null or undefined
            assertParamExists('adminGetMedicalCenterByID', 'medicalCenterId', medicalCenterId)
            const localVarPath = `/be/api/v1/admin/medical-centers/{medical_center_id}/details`
                .replace(`{${"medical_center_id"}}`, encodeURIComponent(String(medicalCenterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the list of currently registered medical centers
         * @summary Admin-List-Medical-Centers
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListMedicalCenters: async (search?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/be/api/v1/admin/medical-centers/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to return all the medical centers paginated
         * @summary Admin-Paginate-Medical-Center
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPaginateMedicalCenter: async (page?: number, size?: number, search?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/be/api/v1/admin/medical-centers/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing medical center
         * @summary Admin-Update-Medical-Center
         * @param {string} medicalCenterId 
         * @param {IMedicalCenterUpdate} iMedicalCenterUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateMedicalCenter: async (medicalCenterId: string, iMedicalCenterUpdate: IMedicalCenterUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'medicalCenterId' is not null or undefined
            assertParamExists('adminUpdateMedicalCenter', 'medicalCenterId', medicalCenterId)
            // verify required parameter 'iMedicalCenterUpdate' is not null or undefined
            assertParamExists('adminUpdateMedicalCenter', 'iMedicalCenterUpdate', iMedicalCenterUpdate)
            const localVarPath = `/be/api/v1/admin/medical-centers/{medical_center_id}`
                .replace(`{${"medical_center_id"}}`, encodeURIComponent(String(medicalCenterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iMedicalCenterUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Medical Center
         * @param {IMedicalCenterCreate} iMedicalCenterCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedicalCenter: async (iMedicalCenterCreate: IMedicalCenterCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iMedicalCenterCreate' is not null or undefined
            assertParamExists('createMedicalCenter', 'iMedicalCenterCreate', iMedicalCenterCreate)
            const localVarPath = `/be/api/v1/admin/medical-centers/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iMedicalCenterCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebAdminMedicalCentersApi - functional programming interface
 * @export
 */
export const WebAdminMedicalCentersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebAdminMedicalCentersApiAxiosParamCreator(configuration)
    return {
        /**
         * API to activate a medical center
         * @summary Admin-Activate-Medical-Center
         * @param {string} medicalCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminActivateMedicalCenter(medicalCenterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IMedicalCenterSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminActivateMedicalCenter(medicalCenterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebAdminMedicalCentersApi.adminActivateMedicalCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to deactivate a medical center
         * @summary Admin-Deactivate-Medical-Center
         * @param {string} medicalCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDectivateMedicalCenter(medicalCenterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IMedicalCenterSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDectivateMedicalCenter(medicalCenterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebAdminMedicalCentersApi.adminDectivateMedicalCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a medical center
         * @summary Admin-Delete-Medical-Center
         * @param {string} medicalCenterId 
         * @param {IMedicalCenterDeleteSchema} iMedicalCenterDeleteSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteMedicalCenter(medicalCenterId: string, iMedicalCenterDeleteSchema: IMedicalCenterDeleteSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteMedicalCenter(medicalCenterId, iMedicalCenterDeleteSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebAdminMedicalCentersApi.adminDeleteMedicalCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a medical center by ID
         * @summary Admin-Get-Medical-Center-By-Id
         * @param {string} medicalCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetMedicalCenterByID(medicalCenterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IMedicalCenterSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetMedicalCenterByID(medicalCenterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebAdminMedicalCentersApi.adminGetMedicalCenterByID']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the list of currently registered medical centers
         * @summary Admin-List-Medical-Centers
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminListMedicalCenters(search?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IMedicalCenterSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminListMedicalCenters(search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebAdminMedicalCentersApi.adminListMedicalCenters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to return all the medical centers paginated
         * @summary Admin-Paginate-Medical-Center
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPaginateMedicalCenter(page?: number, size?: number, search?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPagedResponseSchemaMedicalCenterSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPaginateMedicalCenter(page, size, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebAdminMedicalCentersApi.adminPaginateMedicalCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing medical center
         * @summary Admin-Update-Medical-Center
         * @param {string} medicalCenterId 
         * @param {IMedicalCenterUpdate} iMedicalCenterUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateMedicalCenter(medicalCenterId: string, iMedicalCenterUpdate: IMedicalCenterUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IMedicalCenterSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateMedicalCenter(medicalCenterId, iMedicalCenterUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebAdminMedicalCentersApi.adminUpdateMedicalCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Medical Center
         * @param {IMedicalCenterCreate} iMedicalCenterCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMedicalCenter(iMedicalCenterCreate: IMedicalCenterCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IMedicalCenterSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMedicalCenter(iMedicalCenterCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebAdminMedicalCentersApi.createMedicalCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebAdminMedicalCentersApi - factory interface
 * @export
 */
export const WebAdminMedicalCentersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebAdminMedicalCentersApiFp(configuration)
    return {
        /**
         * API to activate a medical center
         * @summary Admin-Activate-Medical-Center
         * @param {string} medicalCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminActivateMedicalCenter(medicalCenterId: string, options?: RawAxiosRequestConfig): AxiosPromise<IMedicalCenterSchema> {
            return localVarFp.adminActivateMedicalCenter(medicalCenterId, options).then((request) => request(axios, basePath));
        },
        /**
         * API to deactivate a medical center
         * @summary Admin-Deactivate-Medical-Center
         * @param {string} medicalCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDectivateMedicalCenter(medicalCenterId: string, options?: RawAxiosRequestConfig): AxiosPromise<IMedicalCenterSchema> {
            return localVarFp.adminDectivateMedicalCenter(medicalCenterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a medical center
         * @summary Admin-Delete-Medical-Center
         * @param {string} medicalCenterId 
         * @param {IMedicalCenterDeleteSchema} iMedicalCenterDeleteSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteMedicalCenter(medicalCenterId: string, iMedicalCenterDeleteSchema: IMedicalCenterDeleteSchema, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.adminDeleteMedicalCenter(medicalCenterId, iMedicalCenterDeleteSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a medical center by ID
         * @summary Admin-Get-Medical-Center-By-Id
         * @param {string} medicalCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetMedicalCenterByID(medicalCenterId: string, options?: RawAxiosRequestConfig): AxiosPromise<IMedicalCenterSchema> {
            return localVarFp.adminGetMedicalCenterByID(medicalCenterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of currently registered medical centers
         * @summary Admin-List-Medical-Centers
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListMedicalCenters(search?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<IMedicalCenterSchema>> {
            return localVarFp.adminListMedicalCenters(search, options).then((request) => request(axios, basePath));
        },
        /**
         * API to return all the medical centers paginated
         * @summary Admin-Paginate-Medical-Center
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPaginateMedicalCenter(page?: number, size?: number, search?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<IPagedResponseSchemaMedicalCenterSchema> {
            return localVarFp.adminPaginateMedicalCenter(page, size, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing medical center
         * @summary Admin-Update-Medical-Center
         * @param {string} medicalCenterId 
         * @param {IMedicalCenterUpdate} iMedicalCenterUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateMedicalCenter(medicalCenterId: string, iMedicalCenterUpdate: IMedicalCenterUpdate, options?: RawAxiosRequestConfig): AxiosPromise<IMedicalCenterSchema> {
            return localVarFp.adminUpdateMedicalCenter(medicalCenterId, iMedicalCenterUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Medical Center
         * @param {IMedicalCenterCreate} iMedicalCenterCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedicalCenter(iMedicalCenterCreate: IMedicalCenterCreate, options?: RawAxiosRequestConfig): AxiosPromise<IMedicalCenterSchema> {
            return localVarFp.createMedicalCenter(iMedicalCenterCreate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebAdminMedicalCentersApi - object-oriented interface
 * @export
 * @class WebAdminMedicalCentersApi
 * @extends {BaseAPI}
 */
export class WebAdminMedicalCentersApi extends BaseAPI {
    /**
     * API to activate a medical center
     * @summary Admin-Activate-Medical-Center
     * @param {string} medicalCenterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebAdminMedicalCentersApi
     */
    public adminActivateMedicalCenter(medicalCenterId: string, options?: RawAxiosRequestConfig) {
        return WebAdminMedicalCentersApiFp(this.configuration).adminActivateMedicalCenter(medicalCenterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to deactivate a medical center
     * @summary Admin-Deactivate-Medical-Center
     * @param {string} medicalCenterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebAdminMedicalCentersApi
     */
    public adminDectivateMedicalCenter(medicalCenterId: string, options?: RawAxiosRequestConfig) {
        return WebAdminMedicalCentersApiFp(this.configuration).adminDectivateMedicalCenter(medicalCenterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a medical center
     * @summary Admin-Delete-Medical-Center
     * @param {string} medicalCenterId 
     * @param {IMedicalCenterDeleteSchema} iMedicalCenterDeleteSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebAdminMedicalCentersApi
     */
    public adminDeleteMedicalCenter(medicalCenterId: string, iMedicalCenterDeleteSchema: IMedicalCenterDeleteSchema, options?: RawAxiosRequestConfig) {
        return WebAdminMedicalCentersApiFp(this.configuration).adminDeleteMedicalCenter(medicalCenterId, iMedicalCenterDeleteSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a medical center by ID
     * @summary Admin-Get-Medical-Center-By-Id
     * @param {string} medicalCenterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebAdminMedicalCentersApi
     */
    public adminGetMedicalCenterByID(medicalCenterId: string, options?: RawAxiosRequestConfig) {
        return WebAdminMedicalCentersApiFp(this.configuration).adminGetMedicalCenterByID(medicalCenterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the list of currently registered medical centers
     * @summary Admin-List-Medical-Centers
     * @param {string | null} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebAdminMedicalCentersApi
     */
    public adminListMedicalCenters(search?: string | null, options?: RawAxiosRequestConfig) {
        return WebAdminMedicalCentersApiFp(this.configuration).adminListMedicalCenters(search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to return all the medical centers paginated
     * @summary Admin-Paginate-Medical-Center
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string | null} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebAdminMedicalCentersApi
     */
    public adminPaginateMedicalCenter(page?: number, size?: number, search?: string | null, options?: RawAxiosRequestConfig) {
        return WebAdminMedicalCentersApiFp(this.configuration).adminPaginateMedicalCenter(page, size, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing medical center
     * @summary Admin-Update-Medical-Center
     * @param {string} medicalCenterId 
     * @param {IMedicalCenterUpdate} iMedicalCenterUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebAdminMedicalCentersApi
     */
    public adminUpdateMedicalCenter(medicalCenterId: string, iMedicalCenterUpdate: IMedicalCenterUpdate, options?: RawAxiosRequestConfig) {
        return WebAdminMedicalCentersApiFp(this.configuration).adminUpdateMedicalCenter(medicalCenterId, iMedicalCenterUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Medical Center
     * @param {IMedicalCenterCreate} iMedicalCenterCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebAdminMedicalCentersApi
     */
    public createMedicalCenter(iMedicalCenterCreate: IMedicalCenterCreate, options?: RawAxiosRequestConfig) {
        return WebAdminMedicalCentersApiFp(this.configuration).createMedicalCenter(iMedicalCenterCreate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WebAdminStatisticsApi - axios parameter creator
 * @export
 */
export const WebAdminStatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Return monthly statistics (per test type and drafts) for the current medical center
         * @summary Web-Get-Monthly-Statistics
         * @param {string} medicalCenterId 
         * @param {number | null} [month] Month number (default&#x3D;current)
         * @param {number | null} [year] Year number (default&#x3D;current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetMonthlyStatistics: async (medicalCenterId: string, month?: number | null, year?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'medicalCenterId' is not null or undefined
            assertParamExists('webGetMonthlyStatistics', 'medicalCenterId', medicalCenterId)
            const localVarPath = `/be/api/v1/admin/statistics/{medical_center_id}/monthly`
                .replace(`{${"medical_center_id"}}`, encodeURIComponent(String(medicalCenterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return overview statistics for the current medical center
         * @summary Web-Get-Statistics
         * @param {string} medicalCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetStatistics: async (medicalCenterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'medicalCenterId' is not null or undefined
            assertParamExists('webGetStatistics', 'medicalCenterId', medicalCenterId)
            const localVarPath = `/be/api/v1/admin/statistics/{medical_center_id}/overview`
                .replace(`{${"medical_center_id"}}`, encodeURIComponent(String(medicalCenterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebAdminStatisticsApi - functional programming interface
 * @export
 */
export const WebAdminStatisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebAdminStatisticsApiAxiosParamCreator(configuration)
    return {
        /**
         * Return monthly statistics (per test type and drafts) for the current medical center
         * @summary Web-Get-Monthly-Statistics
         * @param {string} medicalCenterId 
         * @param {number | null} [month] Month number (default&#x3D;current)
         * @param {number | null} [year] Year number (default&#x3D;current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webGetMonthlyStatistics(medicalCenterId: string, month?: number | null, year?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IMonthlyStatisticsSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webGetMonthlyStatistics(medicalCenterId, month, year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebAdminStatisticsApi.webGetMonthlyStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return overview statistics for the current medical center
         * @summary Web-Get-Statistics
         * @param {string} medicalCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webGetStatistics(medicalCenterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IStatisticsOverviewSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webGetStatistics(medicalCenterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebAdminStatisticsApi.webGetStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebAdminStatisticsApi - factory interface
 * @export
 */
export const WebAdminStatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebAdminStatisticsApiFp(configuration)
    return {
        /**
         * Return monthly statistics (per test type and drafts) for the current medical center
         * @summary Web-Get-Monthly-Statistics
         * @param {string} medicalCenterId 
         * @param {number | null} [month] Month number (default&#x3D;current)
         * @param {number | null} [year] Year number (default&#x3D;current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetMonthlyStatistics(medicalCenterId: string, month?: number | null, year?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<IMonthlyStatisticsSchema> {
            return localVarFp.webGetMonthlyStatistics(medicalCenterId, month, year, options).then((request) => request(axios, basePath));
        },
        /**
         * Return overview statistics for the current medical center
         * @summary Web-Get-Statistics
         * @param {string} medicalCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetStatistics(medicalCenterId: string, options?: RawAxiosRequestConfig): AxiosPromise<IStatisticsOverviewSchema> {
            return localVarFp.webGetStatistics(medicalCenterId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebAdminStatisticsApi - object-oriented interface
 * @export
 * @class WebAdminStatisticsApi
 * @extends {BaseAPI}
 */
export class WebAdminStatisticsApi extends BaseAPI {
    /**
     * Return monthly statistics (per test type and drafts) for the current medical center
     * @summary Web-Get-Monthly-Statistics
     * @param {string} medicalCenterId 
     * @param {number | null} [month] Month number (default&#x3D;current)
     * @param {number | null} [year] Year number (default&#x3D;current)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebAdminStatisticsApi
     */
    public webGetMonthlyStatistics(medicalCenterId: string, month?: number | null, year?: number | null, options?: RawAxiosRequestConfig) {
        return WebAdminStatisticsApiFp(this.configuration).webGetMonthlyStatistics(medicalCenterId, month, year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return overview statistics for the current medical center
     * @summary Web-Get-Statistics
     * @param {string} medicalCenterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebAdminStatisticsApi
     */
    public webGetStatistics(medicalCenterId: string, options?: RawAxiosRequestConfig) {
        return WebAdminStatisticsApiFp(this.configuration).webGetStatistics(medicalCenterId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WebAdminUsersApi - axios parameter creator
 * @export
 */
export const WebAdminUsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API to create new a user
         * @summary Admin-Create-User
         * @param {IUserCreate} iUserCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateUser: async (iUserCreate: IUserCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iUserCreate' is not null or undefined
            assertParamExists('adminCreateUser', 'iUserCreate', iUserCreate)
            const localVarPath = `/be/api/v1/admin/users/new_user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iUserCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to delete an user. This action will also delete all the user\'s chats and messages!
         * @summary Admin-Delete-User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminDeleteUser', 'userId', userId)
            const localVarPath = `/be/api/v1/admin/users/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the current logged user
         * @summary Admin-Get-User-Details
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetUserDetails: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminGetUserDetails', 'userId', userId)
            const localVarPath = `/be/api/v1/admin/users/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to return all the users
         * @summary Admin-Paginate-Users
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPaginateUsers: async (page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/be/api/v1/admin/users/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebAdminUsersApi - functional programming interface
 * @export
 */
export const WebAdminUsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebAdminUsersApiAxiosParamCreator(configuration)
    return {
        /**
         * API to create new a user
         * @summary Admin-Create-User
         * @param {IUserCreate} iUserCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateUser(iUserCreate: IUserCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IUserSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateUser(iUserCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebAdminUsersApi.adminCreateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to delete an user. This action will also delete all the user\'s chats and messages!
         * @summary Admin-Delete-User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebAdminUsersApi.adminDeleteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the current logged user
         * @summary Admin-Get-User-Details
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetUserDetails(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IUserSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetUserDetails(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebAdminUsersApi.adminGetUserDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to return all the users
         * @summary Admin-Paginate-Users
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPaginateUsers(page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPagedResponseSchemaUserSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPaginateUsers(page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebAdminUsersApi.adminPaginateUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebAdminUsersApi - factory interface
 * @export
 */
export const WebAdminUsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebAdminUsersApiFp(configuration)
    return {
        /**
         * API to create new a user
         * @summary Admin-Create-User
         * @param {IUserCreate} iUserCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateUser(iUserCreate: IUserCreate, options?: RawAxiosRequestConfig): AxiosPromise<IUserSchema> {
            return localVarFp.adminCreateUser(iUserCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * API to delete an user. This action will also delete all the user\'s chats and messages!
         * @summary Admin-Delete-User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteUser(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.adminDeleteUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the current logged user
         * @summary Admin-Get-User-Details
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetUserDetails(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<IUserSchema> {
            return localVarFp.adminGetUserDetails(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * API to return all the users
         * @summary Admin-Paginate-Users
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPaginateUsers(page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<IPagedResponseSchemaUserSchema> {
            return localVarFp.adminPaginateUsers(page, size, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebAdminUsersApi - object-oriented interface
 * @export
 * @class WebAdminUsersApi
 * @extends {BaseAPI}
 */
export class WebAdminUsersApi extends BaseAPI {
    /**
     * API to create new a user
     * @summary Admin-Create-User
     * @param {IUserCreate} iUserCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebAdminUsersApi
     */
    public adminCreateUser(iUserCreate: IUserCreate, options?: RawAxiosRequestConfig) {
        return WebAdminUsersApiFp(this.configuration).adminCreateUser(iUserCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to delete an user. This action will also delete all the user\'s chats and messages!
     * @summary Admin-Delete-User
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebAdminUsersApi
     */
    public adminDeleteUser(userId: string, options?: RawAxiosRequestConfig) {
        return WebAdminUsersApiFp(this.configuration).adminDeleteUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the current logged user
     * @summary Admin-Get-User-Details
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebAdminUsersApi
     */
    public adminGetUserDetails(userId: string, options?: RawAxiosRequestConfig) {
        return WebAdminUsersApiFp(this.configuration).adminGetUserDetails(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to return all the users
     * @summary Admin-Paginate-Users
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebAdminUsersApi
     */
    public adminPaginateUsers(page?: number, size?: number, options?: RawAxiosRequestConfig) {
        return WebAdminUsersApiFp(this.configuration).adminPaginateUsers(page, size, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WebCompaniesApi - axios parameter creator
 * @export
 */
export const WebCompaniesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new company
         * @summary Web-Create-Company
         * @param {ICompanyCreate} iCompanyCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webCreateCompany: async (iCompanyCreate: ICompanyCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iCompanyCreate' is not null or undefined
            assertParamExists('webCreateCompany', 'iCompanyCreate', iCompanyCreate)
            const localVarPath = `/be/api/v1/frontend/companies/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iCompanyCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a company
         * @summary Web-Delete-Company
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webDeleteCompany: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('webDeleteCompany', 'companyId', companyId)
            const localVarPath = `/be/api/v1/frontend/companies/{company_id}`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get company details
         * @summary Web-Get-Company-Details
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetCompanyDetails: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('webGetCompanyDetails', 'companyId', companyId)
            const localVarPath = `/be/api/v1/frontend/companies/{company_id}`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get full list of companies
         * @summary Web-List-Companies
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webListCompanies: async (search?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/be/api/v1/frontend/companies/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated list of companies
         * @summary Web-Paginate-Companies
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webPaginateCompanies: async (page?: number, size?: number, search?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/be/api/v1/frontend/companies/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update company information
         * @summary Web-Update-Company
         * @param {string} companyId 
         * @param {ICompanyUpdate} iCompanyUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webUpdateCompany: async (companyId: string, iCompanyUpdate: ICompanyUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('webUpdateCompany', 'companyId', companyId)
            // verify required parameter 'iCompanyUpdate' is not null or undefined
            assertParamExists('webUpdateCompany', 'iCompanyUpdate', iCompanyUpdate)
            const localVarPath = `/be/api/v1/frontend/companies/{company_id}`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iCompanyUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebCompaniesApi - functional programming interface
 * @export
 */
export const WebCompaniesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebCompaniesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new company
         * @summary Web-Create-Company
         * @param {ICompanyCreate} iCompanyCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webCreateCompany(iCompanyCreate: ICompanyCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ICompanySchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webCreateCompany(iCompanyCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebCompaniesApi.webCreateCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a company
         * @summary Web-Delete-Company
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webDeleteCompany(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webDeleteCompany(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebCompaniesApi.webDeleteCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get company details
         * @summary Web-Get-Company-Details
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webGetCompanyDetails(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ICompanySchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webGetCompanyDetails(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebCompaniesApi.webGetCompanyDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get full list of companies
         * @summary Web-List-Companies
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webListCompanies(search?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ICompanySchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webListCompanies(search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebCompaniesApi.webListCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated list of companies
         * @summary Web-Paginate-Companies
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webPaginateCompanies(page?: number, size?: number, search?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPagedResponseSchemaCompanySchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webPaginateCompanies(page, size, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebCompaniesApi.webPaginateCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update company information
         * @summary Web-Update-Company
         * @param {string} companyId 
         * @param {ICompanyUpdate} iCompanyUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webUpdateCompany(companyId: string, iCompanyUpdate: ICompanyUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ICompanySchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webUpdateCompany(companyId, iCompanyUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebCompaniesApi.webUpdateCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebCompaniesApi - factory interface
 * @export
 */
export const WebCompaniesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebCompaniesApiFp(configuration)
    return {
        /**
         * Create a new company
         * @summary Web-Create-Company
         * @param {ICompanyCreate} iCompanyCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webCreateCompany(iCompanyCreate: ICompanyCreate, options?: RawAxiosRequestConfig): AxiosPromise<ICompanySchema> {
            return localVarFp.webCreateCompany(iCompanyCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a company
         * @summary Web-Delete-Company
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webDeleteCompany(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.webDeleteCompany(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get company details
         * @summary Web-Get-Company-Details
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetCompanyDetails(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ICompanySchema> {
            return localVarFp.webGetCompanyDetails(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get full list of companies
         * @summary Web-List-Companies
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webListCompanies(search?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<ICompanySchema>> {
            return localVarFp.webListCompanies(search, options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated list of companies
         * @summary Web-Paginate-Companies
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webPaginateCompanies(page?: number, size?: number, search?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<IPagedResponseSchemaCompanySchema> {
            return localVarFp.webPaginateCompanies(page, size, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Update company information
         * @summary Web-Update-Company
         * @param {string} companyId 
         * @param {ICompanyUpdate} iCompanyUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webUpdateCompany(companyId: string, iCompanyUpdate: ICompanyUpdate, options?: RawAxiosRequestConfig): AxiosPromise<ICompanySchema> {
            return localVarFp.webUpdateCompany(companyId, iCompanyUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebCompaniesApi - object-oriented interface
 * @export
 * @class WebCompaniesApi
 * @extends {BaseAPI}
 */
export class WebCompaniesApi extends BaseAPI {
    /**
     * Create a new company
     * @summary Web-Create-Company
     * @param {ICompanyCreate} iCompanyCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebCompaniesApi
     */
    public webCreateCompany(iCompanyCreate: ICompanyCreate, options?: RawAxiosRequestConfig) {
        return WebCompaniesApiFp(this.configuration).webCreateCompany(iCompanyCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a company
     * @summary Web-Delete-Company
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebCompaniesApi
     */
    public webDeleteCompany(companyId: string, options?: RawAxiosRequestConfig) {
        return WebCompaniesApiFp(this.configuration).webDeleteCompany(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get company details
     * @summary Web-Get-Company-Details
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebCompaniesApi
     */
    public webGetCompanyDetails(companyId: string, options?: RawAxiosRequestConfig) {
        return WebCompaniesApiFp(this.configuration).webGetCompanyDetails(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get full list of companies
     * @summary Web-List-Companies
     * @param {string | null} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebCompaniesApi
     */
    public webListCompanies(search?: string | null, options?: RawAxiosRequestConfig) {
        return WebCompaniesApiFp(this.configuration).webListCompanies(search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated list of companies
     * @summary Web-Paginate-Companies
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string | null} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebCompaniesApi
     */
    public webPaginateCompanies(page?: number, size?: number, search?: string | null, options?: RawAxiosRequestConfig) {
        return WebCompaniesApiFp(this.configuration).webPaginateCompanies(page, size, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update company information
     * @summary Web-Update-Company
     * @param {string} companyId 
     * @param {ICompanyUpdate} iCompanyUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebCompaniesApi
     */
    public webUpdateCompany(companyId: string, iCompanyUpdate: ICompanyUpdate, options?: RawAxiosRequestConfig) {
        return WebCompaniesApiFp(this.configuration).webUpdateCompany(companyId, iCompanyUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WebDoctorsApi - axios parameter creator
 * @export
 */
export const WebDoctorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Activate doctor
         * @summary Web-Activate-Doctor
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webActivateDoctor: async (doctorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'doctorId' is not null or undefined
            assertParamExists('webActivateDoctor', 'doctorId', doctorId)
            const localVarPath = `/be/api/v1/frontend/doctors/{doctor_id}/activate`
                .replace(`{${"doctor_id"}}`, encodeURIComponent(String(doctorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new doctor (without signature)
         * @summary Web-Create-Doctor
         * @param {IDoctorCreate} iDoctorCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webCreateDoctor: async (iDoctorCreate: IDoctorCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iDoctorCreate' is not null or undefined
            assertParamExists('webCreateDoctor', 'iDoctorCreate', iDoctorCreate)
            const localVarPath = `/be/api/v1/frontend/doctors/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iDoctorCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Dectivate doctor
         * @summary Web-Dectivate-Doctor
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webDectivateDoctor: async (doctorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'doctorId' is not null or undefined
            assertParamExists('webDectivateDoctor', 'doctorId', doctorId)
            const localVarPath = `/be/api/v1/frontend/doctors/{doctor_id}/deactivate`
                .replace(`{${"doctor_id"}}`, encodeURIComponent(String(doctorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a doctor
         * @summary Web-Delete-Doctor
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webDeleteDoctor: async (doctorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'doctorId' is not null or undefined
            assertParamExists('webDeleteDoctor', 'doctorId', doctorId)
            const localVarPath = `/be/api/v1/frontend/doctors/{doctor_id}`
                .replace(`{${"doctor_id"}}`, encodeURIComponent(String(doctorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download an attachment of a doctor
         * @summary Web-Download-Doctor-Attachment
         * @param {IDoctorAttachmentType} attachmentType 
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webDownloadDoctorAttachment: async (attachmentType: IDoctorAttachmentType, doctorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentType' is not null or undefined
            assertParamExists('webDownloadDoctorAttachment', 'attachmentType', attachmentType)
            // verify required parameter 'doctorId' is not null or undefined
            assertParamExists('webDownloadDoctorAttachment', 'doctorId', doctorId)
            const localVarPath = `/be/api/v1/frontend/doctors/{doctor_id}/attachment/{attachment_type}`
                .replace(`{${"attachment_type"}}`, encodeURIComponent(String(attachmentType)))
                .replace(`{${"doctor_id"}}`, encodeURIComponent(String(doctorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a doctor by ID
         * @summary Web-Get-Doctor-By-Id
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetDoctorByID: async (doctorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'doctorId' is not null or undefined
            assertParamExists('webGetDoctorByID', 'doctorId', doctorId)
            const localVarPath = `/be/api/v1/frontend/doctors/{doctor_id}/details`
                .replace(`{${"doctor_id"}}`, encodeURIComponent(String(doctorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get full list of doctors
         * @summary Web-List-Doctors
         * @param {string | null} [search] 
         * @param {boolean | null} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webListDoctors: async (search?: string | null, isActive?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/be/api/v1/frontend/doctors/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated list of doctors
         * @summary Web-Paginate-Doctors
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {boolean | null} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webPaginateDoctors: async (page?: number, size?: number, search?: string | null, isActive?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/be/api/v1/frontend/doctors/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update doctor information
         * @summary Web-Update-Doctor
         * @param {string} doctorId 
         * @param {IDoctorUpdate} iDoctorUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webUpdateDoctor: async (doctorId: string, iDoctorUpdate: IDoctorUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'doctorId' is not null or undefined
            assertParamExists('webUpdateDoctor', 'doctorId', doctorId)
            // verify required parameter 'iDoctorUpdate' is not null or undefined
            assertParamExists('webUpdateDoctor', 'iDoctorUpdate', iDoctorUpdate)
            const localVarPath = `/be/api/v1/frontend/doctors/{doctor_id}`
                .replace(`{${"doctor_id"}}`, encodeURIComponent(String(doctorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iDoctorUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload an attachment of a doctor
         * @summary Web-Upload-Doctor-Attachment
         * @param {IDoctorAttachmentType} attachmentType 
         * @param {string} doctorId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webUploadDoctorAttachment: async (attachmentType: IDoctorAttachmentType, doctorId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentType' is not null or undefined
            assertParamExists('webUploadDoctorAttachment', 'attachmentType', attachmentType)
            // verify required parameter 'doctorId' is not null or undefined
            assertParamExists('webUploadDoctorAttachment', 'doctorId', doctorId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('webUploadDoctorAttachment', 'file', file)
            const localVarPath = `/be/api/v1/frontend/doctors/{doctor_id}/attachment/{attachment_type}`
                .replace(`{${"attachment_type"}}`, encodeURIComponent(String(attachmentType)))
                .replace(`{${"doctor_id"}}`, encodeURIComponent(String(doctorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebDoctorsApi - functional programming interface
 * @export
 */
export const WebDoctorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebDoctorsApiAxiosParamCreator(configuration)
    return {
        /**
         * Activate doctor
         * @summary Web-Activate-Doctor
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webActivateDoctor(doctorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IDoctorSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webActivateDoctor(doctorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebDoctorsApi.webActivateDoctor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new doctor (without signature)
         * @summary Web-Create-Doctor
         * @param {IDoctorCreate} iDoctorCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webCreateDoctor(iDoctorCreate: IDoctorCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IDoctorSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webCreateDoctor(iDoctorCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebDoctorsApi.webCreateDoctor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Dectivate doctor
         * @summary Web-Dectivate-Doctor
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webDectivateDoctor(doctorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IDoctorSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webDectivateDoctor(doctorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebDoctorsApi.webDectivateDoctor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a doctor
         * @summary Web-Delete-Doctor
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webDeleteDoctor(doctorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webDeleteDoctor(doctorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebDoctorsApi.webDeleteDoctor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download an attachment of a doctor
         * @summary Web-Download-Doctor-Attachment
         * @param {IDoctorAttachmentType} attachmentType 
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webDownloadDoctorAttachment(attachmentType: IDoctorAttachmentType, doctorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webDownloadDoctorAttachment(attachmentType, doctorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebDoctorsApi.webDownloadDoctorAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a doctor by ID
         * @summary Web-Get-Doctor-By-Id
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webGetDoctorByID(doctorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IDoctorSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webGetDoctorByID(doctorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebDoctorsApi.webGetDoctorByID']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get full list of doctors
         * @summary Web-List-Doctors
         * @param {string | null} [search] 
         * @param {boolean | null} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webListDoctors(search?: string | null, isActive?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IDoctorSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webListDoctors(search, isActive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebDoctorsApi.webListDoctors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated list of doctors
         * @summary Web-Paginate-Doctors
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {boolean | null} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webPaginateDoctors(page?: number, size?: number, search?: string | null, isActive?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPagedResponseSchemaDoctorSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webPaginateDoctors(page, size, search, isActive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebDoctorsApi.webPaginateDoctors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update doctor information
         * @summary Web-Update-Doctor
         * @param {string} doctorId 
         * @param {IDoctorUpdate} iDoctorUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webUpdateDoctor(doctorId: string, iDoctorUpdate: IDoctorUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IDoctorSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webUpdateDoctor(doctorId, iDoctorUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebDoctorsApi.webUpdateDoctor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload an attachment of a doctor
         * @summary Web-Upload-Doctor-Attachment
         * @param {IDoctorAttachmentType} attachmentType 
         * @param {string} doctorId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webUploadDoctorAttachment(attachmentType: IDoctorAttachmentType, doctorId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IDoctorSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webUploadDoctorAttachment(attachmentType, doctorId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebDoctorsApi.webUploadDoctorAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebDoctorsApi - factory interface
 * @export
 */
export const WebDoctorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebDoctorsApiFp(configuration)
    return {
        /**
         * Activate doctor
         * @summary Web-Activate-Doctor
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webActivateDoctor(doctorId: string, options?: RawAxiosRequestConfig): AxiosPromise<IDoctorSchema> {
            return localVarFp.webActivateDoctor(doctorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new doctor (without signature)
         * @summary Web-Create-Doctor
         * @param {IDoctorCreate} iDoctorCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webCreateDoctor(iDoctorCreate: IDoctorCreate, options?: RawAxiosRequestConfig): AxiosPromise<IDoctorSchema> {
            return localVarFp.webCreateDoctor(iDoctorCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Dectivate doctor
         * @summary Web-Dectivate-Doctor
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webDectivateDoctor(doctorId: string, options?: RawAxiosRequestConfig): AxiosPromise<IDoctorSchema> {
            return localVarFp.webDectivateDoctor(doctorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a doctor
         * @summary Web-Delete-Doctor
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webDeleteDoctor(doctorId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.webDeleteDoctor(doctorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Download an attachment of a doctor
         * @summary Web-Download-Doctor-Attachment
         * @param {IDoctorAttachmentType} attachmentType 
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webDownloadDoctorAttachment(attachmentType: IDoctorAttachmentType, doctorId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.webDownloadDoctorAttachment(attachmentType, doctorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a doctor by ID
         * @summary Web-Get-Doctor-By-Id
         * @param {string} doctorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetDoctorByID(doctorId: string, options?: RawAxiosRequestConfig): AxiosPromise<IDoctorSchema> {
            return localVarFp.webGetDoctorByID(doctorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get full list of doctors
         * @summary Web-List-Doctors
         * @param {string | null} [search] 
         * @param {boolean | null} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webListDoctors(search?: string | null, isActive?: boolean | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<IDoctorSchema>> {
            return localVarFp.webListDoctors(search, isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated list of doctors
         * @summary Web-Paginate-Doctors
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {boolean | null} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webPaginateDoctors(page?: number, size?: number, search?: string | null, isActive?: boolean | null, options?: RawAxiosRequestConfig): AxiosPromise<IPagedResponseSchemaDoctorSchema> {
            return localVarFp.webPaginateDoctors(page, size, search, isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * Update doctor information
         * @summary Web-Update-Doctor
         * @param {string} doctorId 
         * @param {IDoctorUpdate} iDoctorUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webUpdateDoctor(doctorId: string, iDoctorUpdate: IDoctorUpdate, options?: RawAxiosRequestConfig): AxiosPromise<IDoctorSchema> {
            return localVarFp.webUpdateDoctor(doctorId, iDoctorUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload an attachment of a doctor
         * @summary Web-Upload-Doctor-Attachment
         * @param {IDoctorAttachmentType} attachmentType 
         * @param {string} doctorId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webUploadDoctorAttachment(attachmentType: IDoctorAttachmentType, doctorId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<IDoctorSchema> {
            return localVarFp.webUploadDoctorAttachment(attachmentType, doctorId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebDoctorsApi - object-oriented interface
 * @export
 * @class WebDoctorsApi
 * @extends {BaseAPI}
 */
export class WebDoctorsApi extends BaseAPI {
    /**
     * Activate doctor
     * @summary Web-Activate-Doctor
     * @param {string} doctorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebDoctorsApi
     */
    public webActivateDoctor(doctorId: string, options?: RawAxiosRequestConfig) {
        return WebDoctorsApiFp(this.configuration).webActivateDoctor(doctorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new doctor (without signature)
     * @summary Web-Create-Doctor
     * @param {IDoctorCreate} iDoctorCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebDoctorsApi
     */
    public webCreateDoctor(iDoctorCreate: IDoctorCreate, options?: RawAxiosRequestConfig) {
        return WebDoctorsApiFp(this.configuration).webCreateDoctor(iDoctorCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Dectivate doctor
     * @summary Web-Dectivate-Doctor
     * @param {string} doctorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebDoctorsApi
     */
    public webDectivateDoctor(doctorId: string, options?: RawAxiosRequestConfig) {
        return WebDoctorsApiFp(this.configuration).webDectivateDoctor(doctorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a doctor
     * @summary Web-Delete-Doctor
     * @param {string} doctorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebDoctorsApi
     */
    public webDeleteDoctor(doctorId: string, options?: RawAxiosRequestConfig) {
        return WebDoctorsApiFp(this.configuration).webDeleteDoctor(doctorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download an attachment of a doctor
     * @summary Web-Download-Doctor-Attachment
     * @param {IDoctorAttachmentType} attachmentType 
     * @param {string} doctorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebDoctorsApi
     */
    public webDownloadDoctorAttachment(attachmentType: IDoctorAttachmentType, doctorId: string, options?: RawAxiosRequestConfig) {
        return WebDoctorsApiFp(this.configuration).webDownloadDoctorAttachment(attachmentType, doctorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a doctor by ID
     * @summary Web-Get-Doctor-By-Id
     * @param {string} doctorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebDoctorsApi
     */
    public webGetDoctorByID(doctorId: string, options?: RawAxiosRequestConfig) {
        return WebDoctorsApiFp(this.configuration).webGetDoctorByID(doctorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get full list of doctors
     * @summary Web-List-Doctors
     * @param {string | null} [search] 
     * @param {boolean | null} [isActive] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebDoctorsApi
     */
    public webListDoctors(search?: string | null, isActive?: boolean | null, options?: RawAxiosRequestConfig) {
        return WebDoctorsApiFp(this.configuration).webListDoctors(search, isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated list of doctors
     * @summary Web-Paginate-Doctors
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string | null} [search] 
     * @param {boolean | null} [isActive] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebDoctorsApi
     */
    public webPaginateDoctors(page?: number, size?: number, search?: string | null, isActive?: boolean | null, options?: RawAxiosRequestConfig) {
        return WebDoctorsApiFp(this.configuration).webPaginateDoctors(page, size, search, isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update doctor information
     * @summary Web-Update-Doctor
     * @param {string} doctorId 
     * @param {IDoctorUpdate} iDoctorUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebDoctorsApi
     */
    public webUpdateDoctor(doctorId: string, iDoctorUpdate: IDoctorUpdate, options?: RawAxiosRequestConfig) {
        return WebDoctorsApiFp(this.configuration).webUpdateDoctor(doctorId, iDoctorUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload an attachment of a doctor
     * @summary Web-Upload-Doctor-Attachment
     * @param {IDoctorAttachmentType} attachmentType 
     * @param {string} doctorId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebDoctorsApi
     */
    public webUploadDoctorAttachment(attachmentType: IDoctorAttachmentType, doctorId: string, file: File, options?: RawAxiosRequestConfig) {
        return WebDoctorsApiFp(this.configuration).webUploadDoctorAttachment(attachmentType, doctorId, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WebMedicalCentersApi - axios parameter creator
 * @export
 */
export const WebMedicalCentersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get current medical center details
         * @summary Web-Get-Current-Medical-Center-Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetCurrentMedicalCenterDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/be/api/v1/frontend/medical-centers/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update current logged in medical center
         * @summary Web-Update-Current-Medical-Center
         * @param {ICurrentMedicalCenterUpdate} iCurrentMedicalCenterUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webUpdateCurrentMedicalCenter: async (iCurrentMedicalCenterUpdate: ICurrentMedicalCenterUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iCurrentMedicalCenterUpdate' is not null or undefined
            assertParamExists('webUpdateCurrentMedicalCenter', 'iCurrentMedicalCenterUpdate', iCurrentMedicalCenterUpdate)
            const localVarPath = `/be/api/v1/frontend/medical-centers/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iCurrentMedicalCenterUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebMedicalCentersApi - functional programming interface
 * @export
 */
export const WebMedicalCentersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebMedicalCentersApiAxiosParamCreator(configuration)
    return {
        /**
         * Get current medical center details
         * @summary Web-Get-Current-Medical-Center-Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webGetCurrentMedicalCenterDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IMedicalCenterSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webGetCurrentMedicalCenterDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebMedicalCentersApi.webGetCurrentMedicalCenterDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update current logged in medical center
         * @summary Web-Update-Current-Medical-Center
         * @param {ICurrentMedicalCenterUpdate} iCurrentMedicalCenterUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webUpdateCurrentMedicalCenter(iCurrentMedicalCenterUpdate: ICurrentMedicalCenterUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IMedicalCenterSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webUpdateCurrentMedicalCenter(iCurrentMedicalCenterUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebMedicalCentersApi.webUpdateCurrentMedicalCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebMedicalCentersApi - factory interface
 * @export
 */
export const WebMedicalCentersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebMedicalCentersApiFp(configuration)
    return {
        /**
         * Get current medical center details
         * @summary Web-Get-Current-Medical-Center-Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetCurrentMedicalCenterDetails(options?: RawAxiosRequestConfig): AxiosPromise<IMedicalCenterSchema> {
            return localVarFp.webGetCurrentMedicalCenterDetails(options).then((request) => request(axios, basePath));
        },
        /**
         * Update current logged in medical center
         * @summary Web-Update-Current-Medical-Center
         * @param {ICurrentMedicalCenterUpdate} iCurrentMedicalCenterUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webUpdateCurrentMedicalCenter(iCurrentMedicalCenterUpdate: ICurrentMedicalCenterUpdate, options?: RawAxiosRequestConfig): AxiosPromise<IMedicalCenterSchema> {
            return localVarFp.webUpdateCurrentMedicalCenter(iCurrentMedicalCenterUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebMedicalCentersApi - object-oriented interface
 * @export
 * @class WebMedicalCentersApi
 * @extends {BaseAPI}
 */
export class WebMedicalCentersApi extends BaseAPI {
    /**
     * Get current medical center details
     * @summary Web-Get-Current-Medical-Center-Details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebMedicalCentersApi
     */
    public webGetCurrentMedicalCenterDetails(options?: RawAxiosRequestConfig) {
        return WebMedicalCentersApiFp(this.configuration).webGetCurrentMedicalCenterDetails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update current logged in medical center
     * @summary Web-Update-Current-Medical-Center
     * @param {ICurrentMedicalCenterUpdate} iCurrentMedicalCenterUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebMedicalCentersApi
     */
    public webUpdateCurrentMedicalCenter(iCurrentMedicalCenterUpdate: ICurrentMedicalCenterUpdate, options?: RawAxiosRequestConfig) {
        return WebMedicalCentersApiFp(this.configuration).webUpdateCurrentMedicalCenter(iCurrentMedicalCenterUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WebPDFConfigurationsApi - axios parameter creator
 * @export
 */
export const WebPDFConfigurationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new PDF configuration for a medical center
         * @summary Web-Create-Pdf-Configuration
         * @param {IPDFConfigurationCreate} iPDFConfigurationCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webCreatePDFConfiguration: async (iPDFConfigurationCreate: IPDFConfigurationCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iPDFConfigurationCreate' is not null or undefined
            assertParamExists('webCreatePDFConfiguration', 'iPDFConfigurationCreate', iPDFConfigurationCreate)
            const localVarPath = `/be/api/v1/frontend/configuration/pdf/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iPDFConfigurationCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download an attachment of a PDF Configuration
         * @summary Web-Download-Pdf-Configuration-Attachment
         * @param {IPDFConfigAttachmentType} attachmentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webDownloadPDFConfigurationAttachment: async (attachmentType: IPDFConfigAttachmentType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentType' is not null or undefined
            assertParamExists('webDownloadPDFConfigurationAttachment', 'attachmentType', attachmentType)
            const localVarPath = `/be/api/v1/frontend/configuration/pdf/attachment/{attachment_type}`
                .replace(`{${"attachment_type"}}`, encodeURIComponent(String(attachmentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get details of a PDF configuration
         * @summary Web-Get-Pdf-Configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetPDFConfiguration: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/be/api/v1/frontend/configuration/pdf/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a PDF configuration
         * @summary Web-Update-Pdf-Configuration
         * @param {IPDFConfigurationUpdate} iPDFConfigurationUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webUpdatePDFConfiguration: async (iPDFConfigurationUpdate: IPDFConfigurationUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iPDFConfigurationUpdate' is not null or undefined
            assertParamExists('webUpdatePDFConfiguration', 'iPDFConfigurationUpdate', iPDFConfigurationUpdate)
            const localVarPath = `/be/api/v1/frontend/configuration/pdf/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iPDFConfigurationUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload an attachment of a PDF Configuration
         * @summary Web-Upload-Pdf-Configuration-Attachment
         * @param {IPDFConfigAttachmentType} attachmentType 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webUploadPDFConfigurationAttachment: async (attachmentType: IPDFConfigAttachmentType, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentType' is not null or undefined
            assertParamExists('webUploadPDFConfigurationAttachment', 'attachmentType', attachmentType)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('webUploadPDFConfigurationAttachment', 'file', file)
            const localVarPath = `/be/api/v1/frontend/configuration/pdf/attachment/{attachment_type}`
                .replace(`{${"attachment_type"}}`, encodeURIComponent(String(attachmentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebPDFConfigurationsApi - functional programming interface
 * @export
 */
export const WebPDFConfigurationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebPDFConfigurationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new PDF configuration for a medical center
         * @summary Web-Create-Pdf-Configuration
         * @param {IPDFConfigurationCreate} iPDFConfigurationCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webCreatePDFConfiguration(iPDFConfigurationCreate: IPDFConfigurationCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPDFConfigurationSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webCreatePDFConfiguration(iPDFConfigurationCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebPDFConfigurationsApi.webCreatePDFConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download an attachment of a PDF Configuration
         * @summary Web-Download-Pdf-Configuration-Attachment
         * @param {IPDFConfigAttachmentType} attachmentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webDownloadPDFConfigurationAttachment(attachmentType: IPDFConfigAttachmentType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webDownloadPDFConfigurationAttachment(attachmentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebPDFConfigurationsApi.webDownloadPDFConfigurationAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get details of a PDF configuration
         * @summary Web-Get-Pdf-Configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webGetPDFConfiguration(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPDFConfigurationSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webGetPDFConfiguration(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebPDFConfigurationsApi.webGetPDFConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a PDF configuration
         * @summary Web-Update-Pdf-Configuration
         * @param {IPDFConfigurationUpdate} iPDFConfigurationUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webUpdatePDFConfiguration(iPDFConfigurationUpdate: IPDFConfigurationUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPDFConfigurationSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webUpdatePDFConfiguration(iPDFConfigurationUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebPDFConfigurationsApi.webUpdatePDFConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload an attachment of a PDF Configuration
         * @summary Web-Upload-Pdf-Configuration-Attachment
         * @param {IPDFConfigAttachmentType} attachmentType 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webUploadPDFConfigurationAttachment(attachmentType: IPDFConfigAttachmentType, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPDFConfigurationSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webUploadPDFConfigurationAttachment(attachmentType, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebPDFConfigurationsApi.webUploadPDFConfigurationAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebPDFConfigurationsApi - factory interface
 * @export
 */
export const WebPDFConfigurationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebPDFConfigurationsApiFp(configuration)
    return {
        /**
         * Create a new PDF configuration for a medical center
         * @summary Web-Create-Pdf-Configuration
         * @param {IPDFConfigurationCreate} iPDFConfigurationCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webCreatePDFConfiguration(iPDFConfigurationCreate: IPDFConfigurationCreate, options?: RawAxiosRequestConfig): AxiosPromise<IPDFConfigurationSchema> {
            return localVarFp.webCreatePDFConfiguration(iPDFConfigurationCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Download an attachment of a PDF Configuration
         * @summary Web-Download-Pdf-Configuration-Attachment
         * @param {IPDFConfigAttachmentType} attachmentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webDownloadPDFConfigurationAttachment(attachmentType: IPDFConfigAttachmentType, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.webDownloadPDFConfigurationAttachment(attachmentType, options).then((request) => request(axios, basePath));
        },
        /**
         * Get details of a PDF configuration
         * @summary Web-Get-Pdf-Configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetPDFConfiguration(options?: RawAxiosRequestConfig): AxiosPromise<IPDFConfigurationSchema> {
            return localVarFp.webGetPDFConfiguration(options).then((request) => request(axios, basePath));
        },
        /**
         * Update a PDF configuration
         * @summary Web-Update-Pdf-Configuration
         * @param {IPDFConfigurationUpdate} iPDFConfigurationUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webUpdatePDFConfiguration(iPDFConfigurationUpdate: IPDFConfigurationUpdate, options?: RawAxiosRequestConfig): AxiosPromise<IPDFConfigurationSchema> {
            return localVarFp.webUpdatePDFConfiguration(iPDFConfigurationUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload an attachment of a PDF Configuration
         * @summary Web-Upload-Pdf-Configuration-Attachment
         * @param {IPDFConfigAttachmentType} attachmentType 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webUploadPDFConfigurationAttachment(attachmentType: IPDFConfigAttachmentType, file: File, options?: RawAxiosRequestConfig): AxiosPromise<IPDFConfigurationSchema> {
            return localVarFp.webUploadPDFConfigurationAttachment(attachmentType, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebPDFConfigurationsApi - object-oriented interface
 * @export
 * @class WebPDFConfigurationsApi
 * @extends {BaseAPI}
 */
export class WebPDFConfigurationsApi extends BaseAPI {
    /**
     * Create a new PDF configuration for a medical center
     * @summary Web-Create-Pdf-Configuration
     * @param {IPDFConfigurationCreate} iPDFConfigurationCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebPDFConfigurationsApi
     */
    public webCreatePDFConfiguration(iPDFConfigurationCreate: IPDFConfigurationCreate, options?: RawAxiosRequestConfig) {
        return WebPDFConfigurationsApiFp(this.configuration).webCreatePDFConfiguration(iPDFConfigurationCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download an attachment of a PDF Configuration
     * @summary Web-Download-Pdf-Configuration-Attachment
     * @param {IPDFConfigAttachmentType} attachmentType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebPDFConfigurationsApi
     */
    public webDownloadPDFConfigurationAttachment(attachmentType: IPDFConfigAttachmentType, options?: RawAxiosRequestConfig) {
        return WebPDFConfigurationsApiFp(this.configuration).webDownloadPDFConfigurationAttachment(attachmentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get details of a PDF configuration
     * @summary Web-Get-Pdf-Configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebPDFConfigurationsApi
     */
    public webGetPDFConfiguration(options?: RawAxiosRequestConfig) {
        return WebPDFConfigurationsApiFp(this.configuration).webGetPDFConfiguration(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a PDF configuration
     * @summary Web-Update-Pdf-Configuration
     * @param {IPDFConfigurationUpdate} iPDFConfigurationUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebPDFConfigurationsApi
     */
    public webUpdatePDFConfiguration(iPDFConfigurationUpdate: IPDFConfigurationUpdate, options?: RawAxiosRequestConfig) {
        return WebPDFConfigurationsApiFp(this.configuration).webUpdatePDFConfiguration(iPDFConfigurationUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload an attachment of a PDF Configuration
     * @summary Web-Upload-Pdf-Configuration-Attachment
     * @param {IPDFConfigAttachmentType} attachmentType 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebPDFConfigurationsApi
     */
    public webUploadPDFConfigurationAttachment(attachmentType: IPDFConfigAttachmentType, file: File, options?: RawAxiosRequestConfig) {
        return WebPDFConfigurationsApiFp(this.configuration).webUploadPDFConfigurationAttachment(attachmentType, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WebPatientsApi - axios parameter creator
 * @export
 */
export const WebPatientsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new patient
         * @summary Web-Create-Patient
         * @param {IPatientCreate} iPatientCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webCreatePatient: async (iPatientCreate: IPatientCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iPatientCreate' is not null or undefined
            assertParamExists('webCreatePatient', 'iPatientCreate', iPatientCreate)
            const localVarPath = `/be/api/v1/frontend/patients/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iPatientCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a patient
         * @summary Web-Delete-Patient
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webDeletePatient: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('webDeletePatient', 'patientId', patientId)
            const localVarPath = `/be/api/v1/frontend/patients/{patient_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get patient details
         * @summary Web-Get-Patient-Details
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetPatientDetails: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('webGetPatientDetails', 'patientId', patientId)
            const localVarPath = `/be/api/v1/frontend/patients/{patient_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk import patients from CSV file
         * @summary Web-Import-Patients-Csv
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webImportPatientsCSV: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('webImportPatientsCSV', 'file', file)
            const localVarPath = `/be/api/v1/frontend/patients/import-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get full list of patients
         * @summary Web-List-Patients
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webListPatients: async (search?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/be/api/v1/frontend/patients/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated list of patients
         * @summary Web-Paginate-Patients
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webPaginatePatients: async (page?: number, size?: number, search?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/be/api/v1/frontend/patients/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update patient information
         * @summary Web-Update-Patient
         * @param {string} patientId 
         * @param {IPatientUpdate} iPatientUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webUpdatePatient: async (patientId: string, iPatientUpdate: IPatientUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('webUpdatePatient', 'patientId', patientId)
            // verify required parameter 'iPatientUpdate' is not null or undefined
            assertParamExists('webUpdatePatient', 'iPatientUpdate', iPatientUpdate)
            const localVarPath = `/be/api/v1/frontend/patients/{patient_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iPatientUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebPatientsApi - functional programming interface
 * @export
 */
export const WebPatientsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebPatientsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new patient
         * @summary Web-Create-Patient
         * @param {IPatientCreate} iPatientCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webCreatePatient(iPatientCreate: IPatientCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPatientSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webCreatePatient(iPatientCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebPatientsApi.webCreatePatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a patient
         * @summary Web-Delete-Patient
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webDeletePatient(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webDeletePatient(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebPatientsApi.webDeletePatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get patient details
         * @summary Web-Get-Patient-Details
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webGetPatientDetails(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPatientSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webGetPatientDetails(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebPatientsApi.webGetPatientDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bulk import patients from CSV file
         * @summary Web-Import-Patients-Csv
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webImportPatientsCSV(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webImportPatientsCSV(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebPatientsApi.webImportPatientsCSV']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get full list of patients
         * @summary Web-List-Patients
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webListPatients(search?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IPatientSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webListPatients(search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebPatientsApi.webListPatients']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated list of patients
         * @summary Web-Paginate-Patients
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webPaginatePatients(page?: number, size?: number, search?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPagedResponseSchemaPatientSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webPaginatePatients(page, size, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebPatientsApi.webPaginatePatients']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update patient information
         * @summary Web-Update-Patient
         * @param {string} patientId 
         * @param {IPatientUpdate} iPatientUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webUpdatePatient(patientId: string, iPatientUpdate: IPatientUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPatientSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webUpdatePatient(patientId, iPatientUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebPatientsApi.webUpdatePatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebPatientsApi - factory interface
 * @export
 */
export const WebPatientsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebPatientsApiFp(configuration)
    return {
        /**
         * Create a new patient
         * @summary Web-Create-Patient
         * @param {IPatientCreate} iPatientCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webCreatePatient(iPatientCreate: IPatientCreate, options?: RawAxiosRequestConfig): AxiosPromise<IPatientSchema> {
            return localVarFp.webCreatePatient(iPatientCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a patient
         * @summary Web-Delete-Patient
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webDeletePatient(patientId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.webDeletePatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get patient details
         * @summary Web-Get-Patient-Details
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetPatientDetails(patientId: string, options?: RawAxiosRequestConfig): AxiosPromise<IPatientSchema> {
            return localVarFp.webGetPatientDetails(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk import patients from CSV file
         * @summary Web-Import-Patients-Csv
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webImportPatientsCSV(file: File, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.webImportPatientsCSV(file, options).then((request) => request(axios, basePath));
        },
        /**
         * Get full list of patients
         * @summary Web-List-Patients
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webListPatients(search?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<IPatientSchema>> {
            return localVarFp.webListPatients(search, options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated list of patients
         * @summary Web-Paginate-Patients
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webPaginatePatients(page?: number, size?: number, search?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<IPagedResponseSchemaPatientSchema> {
            return localVarFp.webPaginatePatients(page, size, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Update patient information
         * @summary Web-Update-Patient
         * @param {string} patientId 
         * @param {IPatientUpdate} iPatientUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webUpdatePatient(patientId: string, iPatientUpdate: IPatientUpdate, options?: RawAxiosRequestConfig): AxiosPromise<IPatientSchema> {
            return localVarFp.webUpdatePatient(patientId, iPatientUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebPatientsApi - object-oriented interface
 * @export
 * @class WebPatientsApi
 * @extends {BaseAPI}
 */
export class WebPatientsApi extends BaseAPI {
    /**
     * Create a new patient
     * @summary Web-Create-Patient
     * @param {IPatientCreate} iPatientCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebPatientsApi
     */
    public webCreatePatient(iPatientCreate: IPatientCreate, options?: RawAxiosRequestConfig) {
        return WebPatientsApiFp(this.configuration).webCreatePatient(iPatientCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a patient
     * @summary Web-Delete-Patient
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebPatientsApi
     */
    public webDeletePatient(patientId: string, options?: RawAxiosRequestConfig) {
        return WebPatientsApiFp(this.configuration).webDeletePatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get patient details
     * @summary Web-Get-Patient-Details
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebPatientsApi
     */
    public webGetPatientDetails(patientId: string, options?: RawAxiosRequestConfig) {
        return WebPatientsApiFp(this.configuration).webGetPatientDetails(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk import patients from CSV file
     * @summary Web-Import-Patients-Csv
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebPatientsApi
     */
    public webImportPatientsCSV(file: File, options?: RawAxiosRequestConfig) {
        return WebPatientsApiFp(this.configuration).webImportPatientsCSV(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get full list of patients
     * @summary Web-List-Patients
     * @param {string | null} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebPatientsApi
     */
    public webListPatients(search?: string | null, options?: RawAxiosRequestConfig) {
        return WebPatientsApiFp(this.configuration).webListPatients(search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated list of patients
     * @summary Web-Paginate-Patients
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string | null} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebPatientsApi
     */
    public webPaginatePatients(page?: number, size?: number, search?: string | null, options?: RawAxiosRequestConfig) {
        return WebPatientsApiFp(this.configuration).webPaginatePatients(page, size, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update patient information
     * @summary Web-Update-Patient
     * @param {string} patientId 
     * @param {IPatientUpdate} iPatientUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebPatientsApi
     */
    public webUpdatePatient(patientId: string, iPatientUpdate: IPatientUpdate, options?: RawAxiosRequestConfig) {
        return WebPatientsApiFp(this.configuration).webUpdatePatient(patientId, iPatientUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WebReportsApi - axios parameter creator
 * @export
 */
export const WebReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete multiple reports by a list of IDs
         * @summary Web-Bulk-Delete-Reports
         * @param {IReportBulkDeleteRequest} iReportBulkDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webBulkDeleteReports: async (iReportBulkDeleteRequest: IReportBulkDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iReportBulkDeleteRequest' is not null or undefined
            assertParamExists('webBulkDeleteReports', 'iReportBulkDeleteRequest', iReportBulkDeleteRequest)
            const localVarPath = `/be/api/v1/frontend/reports/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iReportBulkDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm a report
         * @summary Web-Confirm-Report
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webConfirmReport: async (reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('webConfirmReport', 'reportId', reportId)
            const localVarPath = `/be/api/v1/frontend/reports/{report_id}/confirm`
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new report (with a new or existing patient)
         * @summary Web-Create-Report
         * @param {IReportCreate} iReportCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webCreateReport: async (iReportCreate: IReportCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iReportCreate' is not null or undefined
            assertParamExists('webCreateReport', 'iReportCreate', iReportCreate)
            const localVarPath = `/be/api/v1/frontend/reports/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iReportCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a report
         * @summary Web-Delete-Report
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webDeleteReport: async (reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('webDeleteReport', 'reportId', reportId)
            const localVarPath = `/be/api/v1/frontend/reports/{report_id}`
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download an attachment of a report (photo blister or patient signature)
         * @summary Web-Download-Report-Attachment
         * @param {IReportAttachmentType} attachmentType 
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webDownloadReportAttachment: async (attachmentType: IReportAttachmentType, reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentType' is not null or undefined
            assertParamExists('webDownloadReportAttachment', 'attachmentType', attachmentType)
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('webDownloadReportAttachment', 'reportId', reportId)
            const localVarPath = `/be/api/v1/frontend/reports/{report_id}/attachment/{attachment_type}`
                .replace(`{${"attachment_type"}}`, encodeURIComponent(String(attachmentType)))
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a structured PDF of a report
         * @summary Web-Generate-Report-Pdf
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGenerateReportPDF: async (reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('webGenerateReportPDF', 'reportId', reportId)
            const localVarPath = `/be/api/v1/frontend/reports/{report_id}/pdf`
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get details of a single report
         * @summary Web-Get-Report-Details
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetReportDetails: async (reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('webGetReportDetails', 'reportId', reportId)
            const localVarPath = `/be/api/v1/frontend/reports/{report_id}/details`
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get full list of reports
         * @summary Web-List-Reports
         * @param {string | null} [search] 
         * @param {string | null} [patientId] 
         * @param {string | null} [doctorId] 
         * @param {string | null} [companyId] 
         * @param {IReportStatus | null} [reportStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webListReports: async (search?: string | null, patientId?: string | null, doctorId?: string | null, companyId?: string | null, reportStatus?: IReportStatus | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/be/api/v1/frontend/reports/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patient_id'] = patientId;
            }

            if (doctorId !== undefined) {
                localVarQueryParameter['doctor_id'] = doctorId;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (reportStatus !== undefined) {
                localVarQueryParameter['report_status'] = reportStatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get full list of reports filtered by patient id
         * @summary Web-List-Reports-By-Patient-Id
         * @param {string} patientId 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webListReportsByPatientID: async (patientId: string, search?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('webListReportsByPatientID', 'patientId', patientId)
            const localVarPath = `/be/api/v1/frontend/reports/patient/{patient_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated list of reports
         * @summary Web-Paginate-Reports
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {string | null} [patientId] 
         * @param {string | null} [doctorId] 
         * @param {string | null} [companyId] 
         * @param {IReportStatus | null} [reportStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webPaginateReports: async (page?: number, size?: number, search?: string | null, patientId?: string | null, doctorId?: string | null, companyId?: string | null, reportStatus?: IReportStatus | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/be/api/v1/frontend/reports/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patient_id'] = patientId;
            }

            if (doctorId !== undefined) {
                localVarQueryParameter['doctor_id'] = doctorId;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (reportStatus !== undefined) {
                localVarQueryParameter['report_status'] = reportStatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retry report photo blister processing
         * @summary Web-Retry-Report-Photo-Blister-Processing
         * @param {string} reportId 
         * @param {IReportRetryProcessing} iReportRetryProcessing 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webRetryReportPhotoBlisterProcessing: async (reportId: string, iReportRetryProcessing: IReportRetryProcessing, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('webRetryReportPhotoBlisterProcessing', 'reportId', reportId)
            // verify required parameter 'iReportRetryProcessing' is not null or undefined
            assertParamExists('webRetryReportPhotoBlisterProcessing', 'iReportRetryProcessing', iReportRetryProcessing)
            const localVarPath = `/be/api/v1/frontend/reports/{report_id}/retry-photo-blister-processing`
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iReportRetryProcessing, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a report
         * @summary Web-Update-Report
         * @param {string} reportId 
         * @param {IReportUpdate} iReportUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webUpdateReport: async (reportId: string, iReportUpdate: IReportUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('webUpdateReport', 'reportId', reportId)
            // verify required parameter 'iReportUpdate' is not null or undefined
            assertParamExists('webUpdateReport', 'iReportUpdate', iReportUpdate)
            const localVarPath = `/be/api/v1/frontend/reports/{report_id}`
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iReportUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload an attachment of a report (photo blister or patient signature)
         * @summary Web-Upload-Report-Attachment
         * @param {IReportAttachmentType} attachmentType 
         * @param {string} reportId 
         * @param {File} file 
         * @param {IDrugTestList | null} [drugTestTypeOverride] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webUploadReportAttachment: async (attachmentType: IReportAttachmentType, reportId: string, file: File, drugTestTypeOverride?: IDrugTestList | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentType' is not null or undefined
            assertParamExists('webUploadReportAttachment', 'attachmentType', attachmentType)
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('webUploadReportAttachment', 'reportId', reportId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('webUploadReportAttachment', 'file', file)
            const localVarPath = `/be/api/v1/frontend/reports/{report_id}/attachment/{attachment_type}`
                .replace(`{${"attachment_type"}}`, encodeURIComponent(String(attachmentType)))
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (drugTestTypeOverride !== undefined) {
                localVarQueryParameter['drug_test_type_override'] = drugTestTypeOverride;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebReportsApi - functional programming interface
 * @export
 */
export const WebReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete multiple reports by a list of IDs
         * @summary Web-Bulk-Delete-Reports
         * @param {IReportBulkDeleteRequest} iReportBulkDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webBulkDeleteReports(iReportBulkDeleteRequest: IReportBulkDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webBulkDeleteReports(iReportBulkDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebReportsApi.webBulkDeleteReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Confirm a report
         * @summary Web-Confirm-Report
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webConfirmReport(reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IReportSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webConfirmReport(reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebReportsApi.webConfirmReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new report (with a new or existing patient)
         * @summary Web-Create-Report
         * @param {IReportCreate} iReportCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webCreateReport(iReportCreate: IReportCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IReportSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webCreateReport(iReportCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebReportsApi.webCreateReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a report
         * @summary Web-Delete-Report
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webDeleteReport(reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webDeleteReport(reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebReportsApi.webDeleteReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download an attachment of a report (photo blister or patient signature)
         * @summary Web-Download-Report-Attachment
         * @param {IReportAttachmentType} attachmentType 
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webDownloadReportAttachment(attachmentType: IReportAttachmentType, reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webDownloadReportAttachment(attachmentType, reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebReportsApi.webDownloadReportAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate a structured PDF of a report
         * @summary Web-Generate-Report-Pdf
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webGenerateReportPDF(reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webGenerateReportPDF(reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebReportsApi.webGenerateReportPDF']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get details of a single report
         * @summary Web-Get-Report-Details
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webGetReportDetails(reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IReportSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webGetReportDetails(reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebReportsApi.webGetReportDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get full list of reports
         * @summary Web-List-Reports
         * @param {string | null} [search] 
         * @param {string | null} [patientId] 
         * @param {string | null} [doctorId] 
         * @param {string | null} [companyId] 
         * @param {IReportStatus | null} [reportStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webListReports(search?: string | null, patientId?: string | null, doctorId?: string | null, companyId?: string | null, reportStatus?: IReportStatus | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IReportSummarySchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webListReports(search, patientId, doctorId, companyId, reportStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebReportsApi.webListReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get full list of reports filtered by patient id
         * @summary Web-List-Reports-By-Patient-Id
         * @param {string} patientId 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webListReportsByPatientID(patientId: string, search?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IReportSummarySchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webListReportsByPatientID(patientId, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebReportsApi.webListReportsByPatientID']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated list of reports
         * @summary Web-Paginate-Reports
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {string | null} [patientId] 
         * @param {string | null} [doctorId] 
         * @param {string | null} [companyId] 
         * @param {IReportStatus | null} [reportStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webPaginateReports(page?: number, size?: number, search?: string | null, patientId?: string | null, doctorId?: string | null, companyId?: string | null, reportStatus?: IReportStatus | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPagedResponseSchemaReportSummarySchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webPaginateReports(page, size, search, patientId, doctorId, companyId, reportStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebReportsApi.webPaginateReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retry report photo blister processing
         * @summary Web-Retry-Report-Photo-Blister-Processing
         * @param {string} reportId 
         * @param {IReportRetryProcessing} iReportRetryProcessing 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webRetryReportPhotoBlisterProcessing(reportId: string, iReportRetryProcessing: IReportRetryProcessing, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IReportSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webRetryReportPhotoBlisterProcessing(reportId, iReportRetryProcessing, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebReportsApi.webRetryReportPhotoBlisterProcessing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a report
         * @summary Web-Update-Report
         * @param {string} reportId 
         * @param {IReportUpdate} iReportUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webUpdateReport(reportId: string, iReportUpdate: IReportUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IReportSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webUpdateReport(reportId, iReportUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebReportsApi.webUpdateReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload an attachment of a report (photo blister or patient signature)
         * @summary Web-Upload-Report-Attachment
         * @param {IReportAttachmentType} attachmentType 
         * @param {string} reportId 
         * @param {File} file 
         * @param {IDrugTestList | null} [drugTestTypeOverride] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webUploadReportAttachment(attachmentType: IReportAttachmentType, reportId: string, file: File, drugTestTypeOverride?: IDrugTestList | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IReportSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webUploadReportAttachment(attachmentType, reportId, file, drugTestTypeOverride, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebReportsApi.webUploadReportAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebReportsApi - factory interface
 * @export
 */
export const WebReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebReportsApiFp(configuration)
    return {
        /**
         * Delete multiple reports by a list of IDs
         * @summary Web-Bulk-Delete-Reports
         * @param {IReportBulkDeleteRequest} iReportBulkDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webBulkDeleteReports(iReportBulkDeleteRequest: IReportBulkDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.webBulkDeleteReports(iReportBulkDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm a report
         * @summary Web-Confirm-Report
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webConfirmReport(reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<IReportSchema> {
            return localVarFp.webConfirmReport(reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new report (with a new or existing patient)
         * @summary Web-Create-Report
         * @param {IReportCreate} iReportCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webCreateReport(iReportCreate: IReportCreate, options?: RawAxiosRequestConfig): AxiosPromise<IReportSchema> {
            return localVarFp.webCreateReport(iReportCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a report
         * @summary Web-Delete-Report
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webDeleteReport(reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.webDeleteReport(reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Download an attachment of a report (photo blister or patient signature)
         * @summary Web-Download-Report-Attachment
         * @param {IReportAttachmentType} attachmentType 
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webDownloadReportAttachment(attachmentType: IReportAttachmentType, reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.webDownloadReportAttachment(attachmentType, reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a structured PDF of a report
         * @summary Web-Generate-Report-Pdf
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGenerateReportPDF(reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.webGenerateReportPDF(reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get details of a single report
         * @summary Web-Get-Report-Details
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetReportDetails(reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<IReportSchema> {
            return localVarFp.webGetReportDetails(reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get full list of reports
         * @summary Web-List-Reports
         * @param {string | null} [search] 
         * @param {string | null} [patientId] 
         * @param {string | null} [doctorId] 
         * @param {string | null} [companyId] 
         * @param {IReportStatus | null} [reportStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webListReports(search?: string | null, patientId?: string | null, doctorId?: string | null, companyId?: string | null, reportStatus?: IReportStatus | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<IReportSummarySchema>> {
            return localVarFp.webListReports(search, patientId, doctorId, companyId, reportStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * Get full list of reports filtered by patient id
         * @summary Web-List-Reports-By-Patient-Id
         * @param {string} patientId 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webListReportsByPatientID(patientId: string, search?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<IReportSummarySchema>> {
            return localVarFp.webListReportsByPatientID(patientId, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated list of reports
         * @summary Web-Paginate-Reports
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [search] 
         * @param {string | null} [patientId] 
         * @param {string | null} [doctorId] 
         * @param {string | null} [companyId] 
         * @param {IReportStatus | null} [reportStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webPaginateReports(page?: number, size?: number, search?: string | null, patientId?: string | null, doctorId?: string | null, companyId?: string | null, reportStatus?: IReportStatus | null, options?: RawAxiosRequestConfig): AxiosPromise<IPagedResponseSchemaReportSummarySchema> {
            return localVarFp.webPaginateReports(page, size, search, patientId, doctorId, companyId, reportStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * Retry report photo blister processing
         * @summary Web-Retry-Report-Photo-Blister-Processing
         * @param {string} reportId 
         * @param {IReportRetryProcessing} iReportRetryProcessing 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webRetryReportPhotoBlisterProcessing(reportId: string, iReportRetryProcessing: IReportRetryProcessing, options?: RawAxiosRequestConfig): AxiosPromise<IReportSchema> {
            return localVarFp.webRetryReportPhotoBlisterProcessing(reportId, iReportRetryProcessing, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a report
         * @summary Web-Update-Report
         * @param {string} reportId 
         * @param {IReportUpdate} iReportUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webUpdateReport(reportId: string, iReportUpdate: IReportUpdate, options?: RawAxiosRequestConfig): AxiosPromise<IReportSchema> {
            return localVarFp.webUpdateReport(reportId, iReportUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload an attachment of a report (photo blister or patient signature)
         * @summary Web-Upload-Report-Attachment
         * @param {IReportAttachmentType} attachmentType 
         * @param {string} reportId 
         * @param {File} file 
         * @param {IDrugTestList | null} [drugTestTypeOverride] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webUploadReportAttachment(attachmentType: IReportAttachmentType, reportId: string, file: File, drugTestTypeOverride?: IDrugTestList | null, options?: RawAxiosRequestConfig): AxiosPromise<IReportSchema> {
            return localVarFp.webUploadReportAttachment(attachmentType, reportId, file, drugTestTypeOverride, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebReportsApi - object-oriented interface
 * @export
 * @class WebReportsApi
 * @extends {BaseAPI}
 */
export class WebReportsApi extends BaseAPI {
    /**
     * Delete multiple reports by a list of IDs
     * @summary Web-Bulk-Delete-Reports
     * @param {IReportBulkDeleteRequest} iReportBulkDeleteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReportsApi
     */
    public webBulkDeleteReports(iReportBulkDeleteRequest: IReportBulkDeleteRequest, options?: RawAxiosRequestConfig) {
        return WebReportsApiFp(this.configuration).webBulkDeleteReports(iReportBulkDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm a report
     * @summary Web-Confirm-Report
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReportsApi
     */
    public webConfirmReport(reportId: string, options?: RawAxiosRequestConfig) {
        return WebReportsApiFp(this.configuration).webConfirmReport(reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new report (with a new or existing patient)
     * @summary Web-Create-Report
     * @param {IReportCreate} iReportCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReportsApi
     */
    public webCreateReport(iReportCreate: IReportCreate, options?: RawAxiosRequestConfig) {
        return WebReportsApiFp(this.configuration).webCreateReport(iReportCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a report
     * @summary Web-Delete-Report
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReportsApi
     */
    public webDeleteReport(reportId: string, options?: RawAxiosRequestConfig) {
        return WebReportsApiFp(this.configuration).webDeleteReport(reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download an attachment of a report (photo blister or patient signature)
     * @summary Web-Download-Report-Attachment
     * @param {IReportAttachmentType} attachmentType 
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReportsApi
     */
    public webDownloadReportAttachment(attachmentType: IReportAttachmentType, reportId: string, options?: RawAxiosRequestConfig) {
        return WebReportsApiFp(this.configuration).webDownloadReportAttachment(attachmentType, reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate a structured PDF of a report
     * @summary Web-Generate-Report-Pdf
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReportsApi
     */
    public webGenerateReportPDF(reportId: string, options?: RawAxiosRequestConfig) {
        return WebReportsApiFp(this.configuration).webGenerateReportPDF(reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get details of a single report
     * @summary Web-Get-Report-Details
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReportsApi
     */
    public webGetReportDetails(reportId: string, options?: RawAxiosRequestConfig) {
        return WebReportsApiFp(this.configuration).webGetReportDetails(reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get full list of reports
     * @summary Web-List-Reports
     * @param {string | null} [search] 
     * @param {string | null} [patientId] 
     * @param {string | null} [doctorId] 
     * @param {string | null} [companyId] 
     * @param {IReportStatus | null} [reportStatus] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReportsApi
     */
    public webListReports(search?: string | null, patientId?: string | null, doctorId?: string | null, companyId?: string | null, reportStatus?: IReportStatus | null, options?: RawAxiosRequestConfig) {
        return WebReportsApiFp(this.configuration).webListReports(search, patientId, doctorId, companyId, reportStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get full list of reports filtered by patient id
     * @summary Web-List-Reports-By-Patient-Id
     * @param {string} patientId 
     * @param {string | null} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReportsApi
     */
    public webListReportsByPatientID(patientId: string, search?: string | null, options?: RawAxiosRequestConfig) {
        return WebReportsApiFp(this.configuration).webListReportsByPatientID(patientId, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated list of reports
     * @summary Web-Paginate-Reports
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string | null} [search] 
     * @param {string | null} [patientId] 
     * @param {string | null} [doctorId] 
     * @param {string | null} [companyId] 
     * @param {IReportStatus | null} [reportStatus] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReportsApi
     */
    public webPaginateReports(page?: number, size?: number, search?: string | null, patientId?: string | null, doctorId?: string | null, companyId?: string | null, reportStatus?: IReportStatus | null, options?: RawAxiosRequestConfig) {
        return WebReportsApiFp(this.configuration).webPaginateReports(page, size, search, patientId, doctorId, companyId, reportStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retry report photo blister processing
     * @summary Web-Retry-Report-Photo-Blister-Processing
     * @param {string} reportId 
     * @param {IReportRetryProcessing} iReportRetryProcessing 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReportsApi
     */
    public webRetryReportPhotoBlisterProcessing(reportId: string, iReportRetryProcessing: IReportRetryProcessing, options?: RawAxiosRequestConfig) {
        return WebReportsApiFp(this.configuration).webRetryReportPhotoBlisterProcessing(reportId, iReportRetryProcessing, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a report
     * @summary Web-Update-Report
     * @param {string} reportId 
     * @param {IReportUpdate} iReportUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReportsApi
     */
    public webUpdateReport(reportId: string, iReportUpdate: IReportUpdate, options?: RawAxiosRequestConfig) {
        return WebReportsApiFp(this.configuration).webUpdateReport(reportId, iReportUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload an attachment of a report (photo blister or patient signature)
     * @summary Web-Upload-Report-Attachment
     * @param {IReportAttachmentType} attachmentType 
     * @param {string} reportId 
     * @param {File} file 
     * @param {IDrugTestList | null} [drugTestTypeOverride] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReportsApi
     */
    public webUploadReportAttachment(attachmentType: IReportAttachmentType, reportId: string, file: File, drugTestTypeOverride?: IDrugTestList | null, options?: RawAxiosRequestConfig) {
        return WebReportsApiFp(this.configuration).webUploadReportAttachment(attachmentType, reportId, file, drugTestTypeOverride, options).then((request) => request(this.axios, this.basePath));
    }
}



